
import { memo, useState, useEffect, useCallback, useMemo, useRef, forwardRef, useImperativeHandle, createRef } from 'react';
import { BzButton, BzInputText, BzToggleButton, BzChip, BzDotsLoader, BzMasterAgGrid, BzDropdown, BzTabs, BzTab, BzToolTip, } from '../../../components';
import { Row, Col, Dropdown, Container, Button } from 'react-bootstrap';
import { TabsScripsList } from '../../Search';
import { WATCHLIST_GRID_INDEX, TL_INDEX, SUPPORT_RESISTANCE_VIEW, ORDER_ENTRY_BUTTON_TOGGLE, APP_INFO_PARAMS, FACILITY_STR, GLOBAL_SEARCH_MIN_LENGTH, ORDER_ENTRY_TYPES, LAYOUT_TYPE, MARKET_SEGMENT_ID, GRID_ROW_SELECTION_TYPE } from "../../../utils/global_variables";
import { handleModal, handleModalData } from '../../../redux/actions/modals';
import { useDispatch, useSelector } from 'react-redux';
import { useDebounce, useWFHMessages } from '../../../hooks';
import { sendTouchlineRequest } from '../../../apis/web_socket';
import { getWfhTouchlineLastTick } from '../../../redux/actions/wfh';
import SupportResistance from '../../Analysis/SupportResistance';
import AllExchangesMarketDepth from '../../AllExchangesMarketDepth';
import { getExchangeWiseScripInfo, getMarketStatus, getOrderMarginInfo, orderMarginInfoSuccess, setShowSideTrayPlaceOrder } from '../../../redux/actions/orders';
import { calculateSupportRestistanceValues, convertEditCart, convertNumberWithCommasForCurrency, deepClone, getApiExchangeNameFromMktSegId, getAppInfoData, getDynamicParamsForToFixed, getMktSegIdFromApiExchangeName, getMktSegIdFromMappedMktSegId } from "../../../utils/global_functions";
import { useLocation } from 'react-router';
import BrokerageModalMultiLeg from './BrokerageModalMultiLeg';
import { toastConfig } from '../../../redux/actions/toast';
import { getOrderCartScrps, getOrderDataBackupVertical, getOrderMarketPriceList, saveCartSuccess, storeGridData, updateOrdercartMargin } from '../../../redux/actions/orderCart';

import { MULTISCRIP_ORDER_CART_GRID_REF, setMultiScripOrderCartGridRef } from '../../../utils/global_functions';
import { getOptionChainData } from '../../../apis';
import { getSearchDataAsPerSearchIndexes } from '../../../controllers/globalSearch';
import { makeGridRowSelected } from '../../../utils/global_functions';
import SurvMeasureModal from './SurvMeasureModal';
import { getSearchScripsEquity } from '../../../redux/actions/globalSearch';
import uniqBy from 'lodash/uniqBy';
import MarketDepthGrid from '../../MarketOverview/MarketDepthGrid';
import { ORDER_PRODUCT_TYPES } from '../../../utils/global_variables';
const objDropdownOptions = {
    // productType: ["DELIVERY", "INTRADAY", "CARRYFORWARD", "MTF", "PTST"],
    productType: [
        { isDefault: true, prodDesc: "Delivery", isSelected: true },
        { isDefault: false, prodDesc: "Margin" },
    ],
    //BT-106965 : Order Cart : Side Tray : ManasaB : 23-07-2024 - Start
    orderType: ["RL", "RL-MKT", "SL", "SL-MKT"],
    validityNSE: ["DAY", "IOC"],
    validityBSE: ["EOSESS", "EOTODY", "IOC"],
    //BT-106965 : Order Cart : Side Tray : ManasaB : 23-07-2024 - End
    arrType: ["BUY", "SELL"],
    exchange: ["NSE", "BSE"],//BT-124975 : ManasaB :11/01/2024 : Order Cart : API Integration for Save Cart and Place Order
    heading: ["BUY/SELL", "SYMBOL", "EXCHANGE", "PROD TYPE", "ORDER TYPE", "QTY", "PRICE", "VALIDITY", "AMO", "SL TRIGGER", "SL LIMIT", ""]
};



const Basket = forwardRef(({ layoutType, orderInfo, onMarketChange, market,
    activeButtonToggleIndex, setActiveButtonToggleIndex, setAddToggle, addToggle,
    arrGlobalScripts, activeTabKey, multiScripOrderActiveTabKey,
    tabSearchToggle, setTabSearchToggle, onAddWatchlist,
    arrMarginInfo, marginInfoHandler, setBIsShowCreateCart, bIsPlaceOrderBtnDisabled, setBIsPlaceOrderBtnDisabled = () => { }, bIsConfirmBack, bIsSaveCartBack, arrAllExchangeWiseProductTypes, setArrAllExchangeWiseProductTypes, ...props }, ref) => {
    const dispatch = useDispatch();
    const activeWatchList = useSelector(state => state.watchList.activeWatchList);
    //BT-106965 : Ordercart : SAT1 Issues : ManasaB : 08-04-2024 -Start
    const [strCartName, setStrCartName] = useState('');
    const [strCartId, setStrCartId] = useState('');
    const objSavedCartDetails = useSelector(state => state?.orderCart?.objCartForGoBack);
    //BT-106965 : Ordercart : SAT1 Issues : ManasaB : 08-04-2024  -End
    const objSelectedCartRowData = useSelector(state => state?.orderCart?.objSelectedCartRowData);   //srikanth
    const arrData = useSelector(state => state?.orderCart?.arrOrderEntryGridData);
    const [rowData, setRowData] = useState([]);
    const [isFlag, setIsFlag] = useState(0);
    const [isShowMarketDepth, setIsShowMarketDepth] = useState(false);
    const [marketDepthActiveTab, setMarketDepthActiveTab] = useState('MarketDepth');
    const [supportResistance, setSupportResistance] = useState({});
    const [orderCartPayloadInfo, setOrderCartPayloadInfo] = useState([]);
    const [orderCartInfo, setOrderCartInfo] = useState([]);
    const [strSearchInputText, setStrSearchInputText] = useState("");
    const [orderBookSearchModal, setOrderBookSearchModal] = useState(false);
    const [globalScripDetails, setGlobalScripDetails] = useState([]);
    const [scripAddedInfo, setScripAddedInfo] = useState([]);
    const [bDisableSaveBtn, setBDisableSaveBtn] = useState(false);
    //for vertical layout
    const arrScripExchanges = useSelector(state => state.orders.arrScripExchanges);
    const arrDistinctScripExchanges = useMemo(() => uniqBy(arrScripExchanges, WATCHLIST_GRID_INDEX.EXCHANGE), [arrScripExchanges]);
    const [marketDepthTab, setMarketDepthTab] = useState(MARKET_SEGMENT_ID.NSE_CASH);
    const productTypes = useSelector(state => state.orders.productTypes);
    const [arrProdTypes, setArrProdTypes] = useState([]);
    const marketStatus = useSelector(state => state.orders.marketStatus);
    const arrOrderCartMarketPriceData = useSelector(state => state.orderCart.arrOrdersMarketPrice)
    const [arrMarketPrice, setArrMarketPrice] = useState([]);
    useEffect(() => {
        if (objSelectedScrip?.['SYMBOL']?.length > 0) {
            setIsShowMarketDepth(false);
            setMarketDepthTab(objSelectedScrip?.['SYMBOL']?.[WATCHLIST_GRID_INDEX.SEGMENT_ID]);
        } else { }
    }, [arrDistinctScripExchanges]);


    const appInfo = useSelector(state => state.appInfo.appInfo);
    const nOrderCartCount = getAppInfoData(APP_INFO_PARAMS?.APP_ORDERCART_ORDER_COUNT, appInfo);
    //To filter data EQ data and to set in state
    //BT-124975 : ManasaB :11/01/2024 : Order Cart : API Integration for Save Cart and Place Order - Start
    setMultiScripOrderCartGridRef(useRef());
    const inputRef = useRef();
    const objModalData = useSelector(state => state?.modals?.modalData);
    const [strIdentifyOrderCartMethod, setStrIdentifyCartMethod] = useState(objModalData?.data?.method);
    const [arrSymbolData, setArrSymbolData] = useState([]);
    const location = useLocation();
    let objLoginSession = useSelector(state => state?.auth?.objLoginSession);
    // {/* Vinit Raut : 16-01-2024 : BT-107249 -  Breeze – SIP Order entry bug fixing BT-102676 -- Start */ }
    const isLoadingMarginInfo = useSelector(state => state.orders.isLoadingMarginInfo);
    // {/* Vinit Raut : 16-01-2024 : BT-107249 -  Breeze – SIP Order entry bug fixing BT-102676 -- End */ }
    const holdingsScrips = useSelector(state => state?.holdings?.holdingsScrips);
    //BT-106965 : Ordercart : SAT1 Issues : ManasaB : 18-04-2024 : Start
    const [arrSurvMeasureData, setArrSurvMeasureData] = useState([]);
    const [isSurvMeasure, setIsSurvMeasure] = useState(false);
    const [isGoBackConfirm, setIsGoBackConfirm] = useState(false);
    const checkGSM = getAppInfoData(APP_INFO_PARAMS.APP_GSM_GRADE_CATEGORY, appInfo);
    const [totalMargin, setTotalMargin] = useState(0.00);
    //BT-106965 : Order Cart : Side Tray : ManasaB : 23-07-2024 - Start
    const [arrScripsData, setArrScripsData] = useState([]);
    const [bIsShowSearchScrip, setBIsShowSearchScrip] = useState(false);
    const [bIsShowScripDetails, setBIsShowScripDetails] = useState(false);
    const [objSelectedScrip, setObjSelectedScrip] = useState({});

    const [objRangeColor, setObjRangeColor] = useState({ price: 'color-text', trigger: 'color-text', limit: 'color-text' });
    const [toggleStopLoss, setToggleStopLoss] = useState(false);
    const arrOrderBackupData = useSelector(state => state.orderCart.arrOrderDataBackupVertical);
    const [isRunOnce, setIsRunOnce] = useState(true); //BREEZE-305 :Watchlist Side tray- Order Cart Order entry :ManasaB : 20-11-2024 : SAT issues 
    //BT-106965 : Order Cart : Side Tray : ManasaB : 23-07-2024 -End
    const objDefaultProductType = productTypes && productTypes?.length > 0 && productTypes?.find(eachProd => eachProd.sDefaultProductType == ORDER_PRODUCT_TYPES.DELIVERY);
    const [objScripsRequest, setObjScripsRequest] = useState({});
    function divideArrayIntoGroups(array, groupSize) {
        let dividedArrays = [];
        let currentIndex = 0;

        while (currentIndex < array?.length) {
            let curentGroup = array?.slice(currentIndex, currentIndex + groupSize);
            dividedArrays?.push(curentGroup);
            currentIndex += groupSize;
        }
        return dividedArrays;
    }
    //BREEZE : 305 : Side tray Order Cart : ManasaB : 20-12-2024 : SAT Issue of AMO session - Start
    useEffect(() => {
        const bIsAmoAllowed = getAppInfoData(APP_INFO_PARAMS.APP_AMO_MODE, appInfo);
        if (bIsAmoAllowed) {
            dispatch(getMarketStatus());
        } else { }
    }, []);
    useEffect(() => {
        setTimeout(() => {
            if (marketStatus?.length > 0 && arrScripsData?.length > 0) {
                arrScripsData?.forEach(eachScrip => {
                    for (let i = 0; i < marketStatus.length; i++) {
                        if (getApiExchangeNameFromMktSegId(eachScrip["SYMBOL"][WATCHLIST_GRID_INDEX.SEGMENT_ID]) == marketStatus[i].exchangeSegment) {
                            if (!eachScrip.amoUpdated) {
                                if (marketStatus[i].marketStatus.toUpperCase() === 'AMO') {
                                    handleAMO({ target: { checked: true } }, eachScrip.id);
                                }
                            }
                            break;
                        } else { }
                    }
                });
            } else { }
        }, 500);
    }, [arrScripsData]);//BREEZE-305:ManasaB : 08-01-2025 : Side tray Order cart SAT2 issue related to AMO
    useEffect(() => {
        if (productTypes?.length > 0) {
            let arrFilteredProductTypes = productTypes.filter(eachProd => eachProd.sDefaultProductType == ORDER_PRODUCT_TYPES.DELIVERY || eachProd.sDefaultProductType == ORDER_PRODUCT_TYPES.MARGIN);
            setArrProdTypes(arrFilteredProductTypes);
        }
    }, [productTypes]);
    //BREEZE : 305 : Side tray Order Cart : ManasaB : 20-12-2024 : SAT Issue of AMO session - End
    useEffect(() => {
        dispatch(updateOrdercartMargin(totalMargin));
    }, [totalMargin, dispatch]);
    const calculatedAndGetOrderMarginInfoFor = async (arrOrderInfo) => {
        let nTotalMargin = 0;
        let nTotalAvailableMargin = 0;
        let devidedArray = divideArrayIntoGroups(arrOrderInfo, 10);
        setTotalMargin(0.00);
        devidedArray?.forEach(async (eachGroupArray) => {
            const arrLegDetails = eachGroupArray.map((eachScrip, i) => {
                return {
                    "LegNo": i + 1,
                    "BuyOrSell": eachScrip["BUY"] === 'BUY' ? 0 : 1,
                    "MarketSegmentId": getMktSegIdFromMappedMktSegId(eachScrip["SYMBOL"][WATCHLIST_GRID_INDEX.MAPPED_SEGMENT_ID]),
                    "Token": eachScrip["SYMBOL"][WATCHLIST_GRID_INDEX.TOKEN],
                    "Quantity": eachScrip["QTY"],
                    "Price": Math.round(eachScrip["PRICE"] * eachScrip["SYMBOL"][WATCHLIST_GRID_INDEX.DECIMAL_LOCATOR]),
                    "MktFlag": eachScrip["ORDER TYPE"].includes('MKT') ? 1 : 0,
                    "OldPrice": 0,
                    "OldQuantity": 0,
                    "ProductType": eachScrip["PROD TYPE"].includes(ORDER_PRODUCT_TYPES.DELIVERY) ? "D" : "M", //BT-106965 : Ordercart : SAT1 Issues : ManasaB : 16-04-2024  
                    "LegIndicator": 0
                };
            });
            let objResp = await dispatch(getOrderMarginInfo(arrLegDetails));
            let nApproxMargin = objResp?.data?.data?.result?.ApproxMargin;
            let nAvailableMargin = objResp?.data?.data?.result?.AvailableMargin;
            nTotalMargin = (parseFloat(nTotalMargin) + parseFloat(nApproxMargin)).toFixed(2);
            nTotalAvailableMargin = (parseFloat(nTotalAvailableMargin) + parseFloat(nAvailableMargin)).toFixed(2);
            setTotalMargin(nTotalMargin);
            let objMarginResult = deepClone(objResp?.data?.data?.result);
            objMarginResult.ApproxMargin = nTotalMargin;
            objMarginResult.AvailableMargin = nTotalAvailableMargin;
            dispatch(orderMarginInfoSuccess(objMarginResult));
        });

    };
    //BT-106965 : Ordercart : SAT1 Issues : ManasaB : 18-04-2024 End
    const BuySellDropDown = (props) => {
        const { setRowData } = props;
        const { rowIndex } = props?.node;
        const arrTransactionType = ["BUY", "SELL"];
        const handleBuySell = (e) => {
            let arrUpdateRowData = [];
            MULTISCRIP_ORDER_CART_GRID_REF?.current?.api?.forEachNode((rowNode, index) => {
                arrUpdateRowData.push(rowNode?.data);
            });//BT-106965 : Ordercart : SAT1 Issues : ManasaB : 16-04-2024  
            arrUpdateRowData[rowIndex]["BUY/SELL"] = e.target.value;
            arrUpdateRowData[rowIndex]["BtnColor"] = e.target.value === 'BUY' ? 'color-positive' : 'color-negative';
            setRowData([...arrUpdateRowData]);
            MULTISCRIP_ORDER_CART_GRID_REF?.current?.api.applyTransaction({
                update: [arrUpdateRowData[rowIndex]]
            });
            // MULTISCRIP_ORDER_CART_GRID_REF?.current?.api.setRowData(arrUpdateRowData);
        };

        return (
            <div className='d-flex align-items-start justify-content-center'>
                {props.data &&
                    <div className='Bzmodalselect-dropdown'>
                        <BzDropdown size='sm'>
                            <Dropdown.Toggle className={`btn-default ${props.data['BtnColor']}`}>{props.data["BUY/SELL"]}</Dropdown.Toggle>
                            <Dropdown.Menu>
                                {arrTransactionType?.map((each, i) => (
                                    <Dropdown.Item key={i} onClick={(e) => { handleBuySell({ target: { name: 'buySellType', value: each } }); }}>{each}</Dropdown.Item>
                                ))}
                            </Dropdown.Menu>
                        </BzDropdown>
                    </div>
                }
            </div>
        );
    };
    const ExchangeDropDown = (props) => {
        const { rowData, setRowData } = props;
        const exchange = ["NSE", "BSE"];
        const { rowIndex } = props?.node;
        const handleExchange = async (e) => {
            let arrMarketPriceList = [];
            const arrUpdateRowData = [...rowData];
            let mktSegId = getMktSegIdFromApiExchangeName(`${e.target.value}_EQ`);
            let exchange = getApiExchangeNameFromMktSegId(mktSegId);
            let data = await getOptionChainData({
                instrumentName: 'EQUITIES', symbol: props.data["SYMBOL"][WATCHLIST_GRID_INDEX.SYMBOL], allowedId: objLoginSession.nExchangesViewAllowed
            });
            const arrWithIndex = getSearchDataAsPerSearchIndexes(data, true);
            let arrFilteredData = arrWithIndex.find(eachData => eachData[WATCHLIST_GRID_INDEX.EXCHANGE_SEGMENT] === exchange);
            let nIndex = arrUpdateRowData.findIndex(eachData => eachData["SYMBOL"][WATCHLIST_GRID_INDEX.SEGMENT_ID_TOKEN] === arrFilteredData[WATCHLIST_GRID_INDEX.SEGMENT_ID_TOKEN]);
            if (nIndex < 0) {
                const arrGlobalData = [...globalScripDetails];
                for (let i = 0; i < arrGlobalData.length; i++) {
                    if (arrGlobalData[i][WATCHLIST_GRID_INDEX.SEGMENT_ID_TOKEN] === arrUpdateRowData[rowIndex]["SYMBOL"][WATCHLIST_GRID_INDEX.SEGMENT_ID_TOKEN]) {
                        arrGlobalData[i] = arrFilteredData;
                    }
                }
                //BT-106965 : Ordercart : SAT2 Issues : ManasaB : 03-06-2024 : Start
                sendTouchlineRequest([
                    { exchangeId: arrFilteredData[WATCHLIST_GRID_INDEX?.SEGMENT_ID]?.length !== 0 ? arrFilteredData[WATCHLIST_GRID_INDEX?.SEGMENT_ID] : 0, token: arrFilteredData[WATCHLIST_GRID_INDEX?.TOKEN]?.length !== 0 ? arrFilteredData[WATCHLIST_GRID_INDEX?.TOKEN] : 0 },
                ]);
                setTimeout(() => {
                    setGlobalScripDetails([...arrGlobalData]);
                    const objLastTickData = dispatch(getWfhTouchlineLastTick());
                    let arrLastTick = objLastTickData[arrFilteredData[WATCHLIST_GRID_INDEX?.SEGMENT_ID_TOKEN]];
                    let nRange = arrLastTick !== undefined ? arrLastTick[TL_INDEX.DAILY_PRICE_RANGE] : '0.00 - 0.00';
                    let price = arrLastTick?.length > 0 ? arrLastTick[TL_INDEX?.LAST_TRADE_PRICE] : '0.00';
                    let objMarketPrice = {
                        id: `${arrFilteredData[WATCHLIST_GRID_INDEX?.SEGMENT_ID_TOKEN]}_${props.data["BUY/SELL"]}`,
                        price
                    };
                    arrMarketPriceList.push(objMarketPrice);
                    setRowData(prevArray => {
                        const arrPrevData = [...prevArray];
                        const newObj = {
                            id: `${arrFilteredData[WATCHLIST_GRID_INDEX?.SEGMENT_ID_TOKEN]}_${props.data["BUY/SELL"]}`,
                            'BUY/SELL': props.data["BUY/SELL"], 'SYMBOL': arrFilteredData,
                            'EXCHANGE': arrFilteredData[WATCHLIST_GRID_INDEX.EXCHANGE],
                            "ORDER TYPE": "RL-MKT",
                            "VALIDITY": arrFilteredData[WATCHLIST_GRID_INDEX.EXCHANGE] == 'NSE' ? "DAY" : 'EOSESS',
                            "QTY": arrFilteredData[WATCHLIST_GRID_INDEX.REGULAR_LOT] > 0 ? arrFilteredData[WATCHLIST_GRID_INDEX.REGULAR_LOT] : 1,
                            "PRICE": arrLastTick?.length > 0 ? arrLastTick[TL_INDEX?.LAST_TRADE_PRICE] : 0,
                            "PROD TYPE": objDefaultProductType.sDescription, "SL LIMIT": '0.00', "SL TRIGGER": '0.00',
                            "AMO": false, "BtnColor": props.data["BUY/SELL"] === 'BUY' ? 'color-positive' : 'color-negative',
                            "Range": parseFloat(Number(arrFilteredData[WATCHLIST_GRID_INDEX.DAILY_PRICE_RANGE])) !== 0 ? arrFilteredData[WATCHLIST_GRID_INDEX.DAILY_PRICE_RANGE] : nRange,
                            "amoUpdated": false
                        };
                        arrPrevData[rowIndex] = newObj;
                        setArrMarketPrice(arrMarketPriceList);
                        dispatch(getOrderMarketPriceList(arrMarketPriceList));
                        return arrPrevData;
                    });
                }, 200);
                //BT-106965 : Ordercart : SAT2 Issues : ManasaB : 03-06-2024 : End
            }

            else {
                dispatch(toastConfig({ autoDismiss: true, show: true, message: `Selected exchange scrip is already exist in ordercart. Please choose other exchange and try again.` }));
            }
        };
        return (
            <div className='d-flex align-items-start justify-content-center'>
                {props.data &&
                    <div className='Bzmodalselect-dropdown'>
                        <BzDropdown size='sm'>
                            <Dropdown.Toggle className={`btn-default`}>{props.data["EXCHANGE"]}</Dropdown.Toggle>
                            <Dropdown.Menu>
                                {exchange?.map((each, i) => (
                                    <Dropdown.Item key={i} onClick={(e) => { handleExchange({ target: { name: 'exchange', value: each } }); }}>{each}</Dropdown.Item>
                                ))}
                            </Dropdown.Menu>
                        </BzDropdown>
                    </div>
                }
            </div>
        );
    };
    //BT-106965 : Order Cart : ManasaB : 12/03/2024 : Adding Market Depth Value - Start
    const onValueClick = useCallback((nValue, i) => {
        if (layoutType === LAYOUT_TYPE.HORIZONTAL) {
            let objSelectedGridData = MULTISCRIP_ORDER_CART_GRID_REF?.current?.api?.getSelectedRows()[0];
            const exchangeName = getApiExchangeNameFromMktSegId(getMktSegIdFromMappedMktSegId(objSelectedGridData["SYMBOL"][WATCHLIST_GRID_INDEX.MAPPED_SEGMENT_ID]));
            const decimalLocatorLength = getDynamicParamsForToFixed(exchangeName);
            if (!objSelectedGridData["ORDER TYPE"].includes('MKT')) {
                if (objSelectedGridData["ORDER TYPE"].includes("SL")) {
                    let objUpdatedData = { ...objSelectedGridData, "SL LIMIT": nValue.toFixed(decimalLocatorLength) };
                    MULTISCRIP_ORDER_CART_GRID_REF?.current?.api?.applyTransaction({
                        update: [objUpdatedData]
                    });
                }
                else {
                    let objUpdatedData = { ...objSelectedGridData, "PRICE": nValue.toFixed(decimalLocatorLength) };
                    MULTISCRIP_ORDER_CART_GRID_REF?.current?.api?.applyTransaction({
                        update: [objUpdatedData]
                    });
                }

            }
        }
        else if (layoutType === LAYOUT_TYPE.VERTICAL) {
            let objToUpdate = arrScripsData.find(eachScrip => eachScrip.id === objSelectedScrip.id);
            const exchangeName = getApiExchangeNameFromMktSegId(getMktSegIdFromMappedMktSegId(objToUpdate["SYMBOL"][WATCHLIST_GRID_INDEX.MAPPED_SEGMENT_ID]));
            const decimalLocatorLength = getDynamicParamsForToFixed(exchangeName);
            if (!objToUpdate["ORDER TYPE"].includes('MKT')) {
                if (objToUpdate["ORDER TYPE"] === ORDER_ENTRY_TYPES.SL) {
                    setArrScripsData(prevData => prevData.map(eachData => eachData.id === objToUpdate.id ? { ...eachData, "SL LIMIT": nValue.toFixed(decimalLocatorLength) } : eachData));
                    setTimeout(() => {
                        checkTriggerValue(objSelectedScrip);
                    }, 200);

                }
                else {
                    setArrScripsData(prevData => prevData.map(eachData => eachData.id === objToUpdate.id ? { ...eachData, "PRICE": nValue.toFixed(decimalLocatorLength) } : eachData));
                }

            }
        }
    }, [objSelectedScrip, arrScripsData]);
    const checkTriggerValue = useCallback((objSelectedScripInfo) => {
        let objToUpdate = arrScripsData.find(eachScrip => eachScrip.id === objSelectedScripInfo.id);
        if (parseFloat(Number(objToUpdate["SL TRIGGER"])) == 0) {
            setBIsPlaceOrderBtnDisabled(true);
        }
    }, [arrScripsData]);
    //BT-106965 : Order Cart : ManasaB : 12/03/2024 : Adding Market Depth Value - End
    const OrderTypeDropDown = (props) => {
        const { setBDisableSaveBtn, rowData } = props;
        const { rowIndex } = props?.node;
        const handleOrderType = (e) => {
            props?.setValue(e.target.value);
            if (e.target.value === ORDER_ENTRY_TYPES.SL) {
                if (parseFloat(Number(props?.data["SL TRIGGER"])) == 0 || parseFloat(Number(props?.data["SL LIMIT"] == 0))) {
                    setBDisableSaveBtn(true);
                }

            }
            else if (e.target.value === ORDER_ENTRY_TYPES.SL_MKT) {
                if (parseFloat(Number(props?.data["SL TRIGGER"])) == 0) {
                    setBDisableSaveBtn(true);
                }
            }
            else {
                if (e.target.value === ORDER_ENTRY_TYPES.RL_MKT) {
                    let objMarketPrice = arrMarketPrice.find(eachData => eachData.id === props?.data.id);
                    setRowData(prevData => prevData.map((eachData, index) => index == rowIndex ? { ...eachData, "PRICE": objMarketPrice.price } : eachData));
                }
                setBDisableSaveBtn(false);
            }
            MULTISCRIP_ORDER_CART_GRID_REF?.current?.api?.refreshCells({ force: true });
        };
        const arrOrderType = ["RL", "RL-MKT", "SL", "SL-MKT"];
        return (
            <div className='d-flex align-items-start justify-content-center'>
                {props.data &&
                    <div className='Bzmodalselect-dropdown'>
                        <BzDropdown size='sm'>
                            <Dropdown.Toggle className={`btn-default`}>{props.data["ORDER TYPE"]}</Dropdown.Toggle>
                            <Dropdown.Menu>
                                {arrOrderType?.map((each, i) => (
                                    <Dropdown.Item key={i} onClick={(e) => { handleOrderType({ target: { name: 'orderType', value: each } }); }}>{each}</Dropdown.Item>
                                ))}
                            </Dropdown.Menu>
                        </BzDropdown>
                    </div>
                }
            </div>
        );
    };
    //BT-106965 : Ordercart : SAT1 Issues : ManasaB : 15-04-2024 : Added null checkes - Start
    const ProductTypeDropDownComponent = (props) => {
        const { rowData, arrProdTypes } = props;
        const arrProductType = ["Delivery", "Margin"];
        const handleProductType = (e) => {
            props?.setValue(e.target.value);
            handleMarginInfo(rowData); //BT-106965 : Ordercart : SAT1 Issues : ManasaB : 16-04-2024  
        };
        return (
            <div className='d-flex align-items-start justify-content-center'>
                {props.data &&
                    <div className='Bzmodalselect-dropdown'>
                        <BzDropdown size='sm'>
                            <Dropdown.Toggle className={`btn-default oe-multiscrip-prod-type-select`}>{props.data["PROD TYPE"].toUpperCase()}</Dropdown.Toggle>
                            <Dropdown.Menu>
                                {arrProdTypes.map((each, i) => (
                                    <Dropdown.Item key={i} onClick={(e) => { handleProductType({ target: { name: 'productType', value: each.sDefaultProductType } }); }}>{each.sDescription}</Dropdown.Item>
                                ))}
                            </Dropdown.Menu>
                        </BzDropdown>
                    </div>
                }
            </div>
        );

    };
    const AmoComponent = (props) => {
        const { marketStatus, rowData } = props;
        const handleOnChange = (e) => {
            props?.setValue(!props?.getValue());
        };
        const handleAMOH = (e, id) => {
            setRowData((prevData) =>
                prevData.map(eachData => eachData.id == id ? { ...eachData, AMO: e.target.checked, amoUpdated: true } : eachData)
            );
        };

        useEffect(() => {
            setTimeout(() => {
                if (marketStatus?.length > 0 && rowData?.length > 0) {
                    rowData?.forEach(eachScrip => {
                        for (let i = 0; i < marketStatus.length; i++) {
                            if (getApiExchangeNameFromMktSegId(eachScrip["SYMBOL"][WATCHLIST_GRID_INDEX.SEGMENT_ID]) == marketStatus[i].exchangeSegment) {
                                if (!eachScrip.amoUpdated) {
                                    if (marketStatus[i].marketStatus.toUpperCase() === 'AMO') {
                                        handleAMOH({ target: { checked: true } }, eachScrip.id);
                                    }
                                }
                                break;
                            } else { }
                        }
                    });
                } else { }
            }, 500);
        }, [rowData, marketStatus]);
        return (
            <div className='d-flex align-items-start justify-content-center pt-2'>
                <div className='input-group d-flex justify-content-center'>
                    <input type='checkbox' className='form-check-input' name="amo" checked={props.data["AMO"]} onChange={handleOnChange.bind(this)}></input>
                </div>
            </div>
        );
    };
    const ValidityDropDown = (props) => {
        const { rowData, setRowData } = props;

        const handleValidity = (e) => {
            props?.setValue(e.target.value);

        };
        const arrValidityNSE = ["DAY", "IOC"];
        const arrValidityBSE = ["EOSESS", "EOTODY", "IOC"];
        const arrValidityDropDown = props.data["EXCHANGE"] === "NSE" ? arrValidityNSE : arrValidityBSE;
        return (
            <div className='d-flex align-items-start justify-content-center'>
                {props.data &&
                    <div className='Bzmodalselect-dropdown'>
                        <BzDropdown size='sm'>
                            <Dropdown.Toggle className={`btn-default`}>{props.data["VALIDITY"]}</Dropdown.Toggle>
                            <Dropdown.Menu>
                                {arrValidityDropDown?.map((each, i) => (
                                    <Dropdown.Item key={i} onClick={(e) => { handleValidity({ target: { name: 'validity', value: each } }); }}>{each}</Dropdown.Item>
                                ))}
                            </Dropdown.Menu>
                        </BzDropdown>
                    </div>
                }
            </div>
        );
    };
    const QuantityComponent = (props) => {
        const { rowIndex } = props?.node;
        //BT-106965 : Ordercart : SAT1 Issues : ManasaB : 08-04-2024 : 
        let nIncrementValue = parseInt(props.data["SYMBOL"][WATCHLIST_GRID_INDEX.REGULAR_LOT]);
        const handleQuantity = (e) => {
            if (parseInt(e.target.value) <= 0) {
                setBDisableSaveBtn(true);
            } else if (!e?.target?.value?.includes('.') && e.target.value < 99999999)
                props?.setValue(e.target.value);
            setBDisableSaveBtn(false);
        };
        const handleIncDec = (name, index) => {
            switch (name) {
                case "subQuantity":
                    if (props.data["QTY"] > nIncrementValue) {
                        props.setValue(Number(props.getValue()) - nIncrementValue);
                        setBDisableSaveBtn(false);
                    } else { };
                    break;
                case "addQuantity":
                    if (props.getValue() < 99999999)
                        props.setValue(Number(props.getValue()) + nIncrementValue);
                    setBDisableSaveBtn(false);
                    break;
                default:
            }
        };
        //BT-106965 : Ordercart : SAT1 Issues : ManasaB : 08-04-2024 -End
        const handleBlur = useCallback((e) => {
            e.preventDefault();
            if (props?.getValue() === '') {
                setBDisableSaveBtn(true);
            }
            else {
                setBDisableSaveBtn(false);
            }
        }, []);
        return (
            <div className='d-flex align-items-center justify-content-center pt-2'>
                <div className='input-group position-relative'>
                    <div className='icon-12 icon-order-decrease input-number-left-wrap' onClick={handleIncDec.bind(this, "subQuantity", rowIndex)}> </div>
                    {/* ManasaB:30-09-2024 : Solved ui adjustment issue from smoketesting : Added w_100 in below classname */}
                    {props.data && <BzInputText size='sm' type='text' className='font-regular text-center w_100' name="count" onChange={handleQuantity.bind(this)} value={props.data["QTY"]} onBlur={handleBlur.bind(this)} />}
                    <div className='icon-12 icon-order-increase input-number-right-wrap' onClick={() => handleIncDec("addQuantity", rowIndex)} ></div>
                </div>
            </div>
        );
    };
    const PriceComponent = (props) => {
        const { setBDisableSaveBtn } = props;
        const { rowIndex } = props?.node;
        //BT-106965 : Ordercart : SAT1 Issues : ManasaB : 16-04-2024  - Start
        const bDisable = !["RL"]?.includes(props.data["ORDER TYPE"]);
        let arrRange = props?.data["Range"] !== '0.00-0.00' ? props?.data["Range"]?.split("-") : [];
        let minRange = arrRange?.length > 0 ? parseFloat(arrRange[0]) : 0;
        let maxRange = arrRange?.length > 0 ? parseFloat(arrRange[1]) : 0;

        const [rangeColor, setRangeColor] = useState('color-text');
        useEffect(() => {
            if ((props.data["ORDER TYPE"] === ORDER_ENTRY_TYPES.RL)) {
                if (parseFloat(Number(props?.getValue())) === 0) {
                    setBDisableSaveBtn(true);
                    setRangeColor('color-error');
                }
                else if (parseFloat(Number(props?.getValue())) > maxRange || parseFloat(Number(props?.getValue())) < minRange) {
                    setRangeColor('color-error');
                }
                else {
                    setBDisableSaveBtn(false);
                    setRangeColor('color-text');
                }
            }
        }, [props]);

        const handlePrice = (e) => {
            e.preventDefault();
            let { value } = e.target;
            value = value?.replace(/[^0-9.]/g, '');
            let decimalCount = value?.split('.').length - 1;
            if (decimalCount > 1) {
                value = value.slice(0, value.lastIndexOf('.'));
            }
            let valueParts = value.split('.');
            if (valueParts[1] && valueParts[1].length > props.data["SYMBOL"][WATCHLIST_GRID_INDEX.DECIMAL_LOCATOR_LENGTH]) {
                value = `${valueParts[0]}.${valueParts[1].slice(0, 2)}`;
            }
            props.setValue(value);
        };
        const onhandleMarketDepth = useCallback((e, arrActiveScripInformation) => {
            setIsShowMarketDepth(curr => {
                if (!curr && props?.data?.SYMBOL?.length) {
                    dispatch(getExchangeWiseScripInfo(props?.data?.SYMBOL));
                }
                return !curr;
            });
            if (arrActiveScripInformation?.length !== 0) {
                makeGridRowSelected(MULTISCRIP_ORDER_CART_GRID_REF, rowIndex);
                const resitancePivotObj = calculateSupportRestistanceValues(arrActiveScripInformation, 'Classic', '(H+L+C)/3');
                setSupportResistance(resitancePivotObj);
            } else { }
        }, []);
        const handleIncDec = (name, index) => {
            switch (name) {
                case "subPrice":
                    if (props?.getValue() > 0) {
                        props?.setValue((parseFloat(props?.getValue()) - props.data["SYMBOL"][WATCHLIST_GRID_INDEX.PRICE_TICK]).toFixed(props.data["SYMBOL"][WATCHLIST_GRID_INDEX.DECIMAL_LOCATOR_LENGTH]));
                    } else { };
                    break;
                case "addPrice": {
                    if (props?.value?.length <= 0) {
                        props?.setValue(props.data["SYMBOL"][WATCHLIST_GRID_INDEX.PRICE_TICK]).toFixed(props.data["SYMBOL"][WATCHLIST_GRID_INDEX.DECIMAL_LOCATOR_LENGTH]);
                        setBDisableSaveBtn(false);
                        break;
                    } else {
                        props?.setValue((parseFloat(props?.value) + props.data["SYMBOL"][WATCHLIST_GRID_INDEX.PRICE_TICK]).toFixed(props.data["SYMBOL"][WATCHLIST_GRID_INDEX.DECIMAL_LOCATOR_LENGTH]));
                        setBDisableSaveBtn(false);
                        break;
                    }


                }
                default:
            }
        };
        const handleBlur = useCallback((e) => {
            e.preventDefault();
            if (props?.getValue() === '') {
                setBDisableSaveBtn(true);
                setRangeColor('color-text');
            }
            else {
                if (!props?.getValue()?.toString()?.includes('.')) {
                    props?.setValue(parseFloat(props?.getValue()).toFixed(props.data["SYMBOL"][WATCHLIST_GRID_INDEX.DECIMAL_LOCATOR_LENGTH]));
                }

                if (parseFloat(props?.getValue()) <= 0) {
                    setBDisableSaveBtn(true);
                    setRangeColor('color-error');
                }
                else {
                    if (parseFloat(props?.getValue()) > maxRange || parseFloat(props?.getValue()) < minRange) {
                        setBDisableSaveBtn(true);
                        setRangeColor('color-error');
                    }
                    else {
                        setBDisableSaveBtn(false);
                        setRangeColor('color-subtext');
                    }
                }
            }
        }, []);
        return (
            <>
                <div className='d-flex align-items-center justify-content-center pt-2'>
                    <div className={`input-group position-relative ${bDisable ? 'disabled' : ''}`}>
                        <div className={`icon-12 icon-order-decrease input-number-left-wrap ${bDisable && 'div-disabled'}`} onClick={handleIncDec.bind(this, "subPrice")}> </div>
                        <BzInputText disabled={bDisable} size='sm' type='text' className='font-regular text-center' name="price" onChange={(e) => handlePrice(e)} value={props?.value} onBlur={handleBlur.bind(this)} />
                        <div className={`icon-12 icon-order-increase input-number-right-wrap ${bDisable && 'div-disabled'}`} onClick={handleIncDec.bind(this, "addPrice")}></div>
                    </div>
                    <div className='icon-20 icon-marketdepth ms-2 me-1' onClick={(e) => onhandleMarketDepth(e)}></div>
                </div>
                <div className='font-medium font-size1 color-subtext range-container mt-1'>Range: <span className={`${rangeColor}`}>{props.data["Range"]}</span></div>
            </>
        );
    };
    const SymbolComponent = (props) => {
        const [arrCartSymbolData, setArrCartSymbolData] = useState([]);
        useEffect(() => {
            if (props?.data) {
                setArrCartSymbolData(props?.data["SYMBOL"]);
            }
        }, []);
        return (
            <>
                {arrCartSymbolData && arrCartSymbolData?.length > 0 &&
                    <>
                        <div className='d-flex align-items-center justify-content-start pt-2'>
                            <div className='d-flex flex-column justify-content-start'>
                                <div className='d-flex align-items-center range-container'>
                                    <div className='font-medium font-size2 color-text text-uppercase me-2'>{arrCartSymbolData?.[WATCHLIST_GRID_INDEX.SYMBOL]}</div>
                                    <span className='font-regular font-size2 color-subtext text-uppercase'>{arrCartSymbolData?.[WATCHLIST_GRID_INDEX.SERIES]}</span>
                                </div>
                                <div className='d-flex align-items-center range-container'>
                                    <div className='font-regular font-size1 color-text pe-2'>{arrCartSymbolData?.[WATCHLIST_GRID_INDEX.LAST_TRADE_PRICE] ? arrCartSymbolData?.[WATCHLIST_GRID_INDEX.LAST_TRADE_PRICE] : '0.00'}</div>
                                    <div className={`font-regular font-size1 color-text ${Number(arrCartSymbolData[WATCHLIST_GRID_INDEX.CHANGE_IN_LTP]) >= 0 ? 'color-positive' : 'color-negative'}`}>{arrCartSymbolData[WATCHLIST_GRID_INDEX.CHANGE_IN_LTP] ? arrCartSymbolData[WATCHLIST_GRID_INDEX.CHANGE_IN_LTP] : '0.00'} ({arrCartSymbolData[WATCHLIST_GRID_INDEX.LTP_PERCENT] ? arrCartSymbolData[WATCHLIST_GRID_INDEX.LTP_PERCENT] : '0.00'}%)</div>
                                </div>
                            </div>

                        </div>
                    </>
                }
            </>
        );
    };
    //BT-106965 : Ordercart : SAT2 Issues : ManasaB : 03-06-2024 : Start
    useEffect(() => {
        if (rowData?.length > 0) {
            dispatch(storeGridData(rowData));
        }
    }, [rowData]);
    //BT-106965 : Ordercart : SAT2 Issues : ManasaB : 03-06-2024 : End
    const SlLimitComponent = (props) => {
        const { bDisableSaveBtn, setBDisableSaveBtn } = props;
        const { rowIndex } = props?.node;
        const bDisable = !["SL"]?.includes(props.data["ORDER TYPE"]);
        let arrRange = props.data["Range"] !== '0.00-0.00' ? props.data["Range"]?.split("-") : [];
        let minRange = arrRange.length > 0 ? parseFloat(arrRange[0]) : 0;
        let maxRange = arrRange.length > 0 ? parseFloat(arrRange[1]) : 0;
        const [rangeColor, setRangeColor] = useState('color-text');
        useEffect(() => {
            if (props.data["ORDER TYPE"] === 'SL') {
                if (parseInt(Number(props?.getValue())) === 0) {
                    setBDisableSaveBtn(true);
                    setRangeColor('color-error');
                }
                else if (parseInt(Number(props?.getValue())) > maxRange || parseInt(Number(props?.getValue())) < minRange) {
                    setRangeColor('color-error');
                }
            }
        }, [props]); //BT-106965 : Ordercart :Regression : ManasaB : 26-06-2024
        const handleSlLimit = (e) => {
            e.preventDefault();
            let { value } = e.target;
            value = value?.replace(/[^0-9.]/g, '');
            let decimalCount = value.split('.').length - 1;
            if (decimalCount > 1) {
                value = value?.slice(0, value.lastIndexOf('.'));
            }
            let valueParts = value.split('.');
            if (valueParts[1] && valueParts[1].length > props.data["SYMBOL"][WATCHLIST_GRID_INDEX.DECIMAL_LOCATOR_LENGTH]) {
                value = `${valueParts[0]}.${valueParts[1].slice(0, 2)}`;
            }
            props?.setValue(value);
        };
        const handleBlur = useCallback((e) => {
            e.preventDefault();
            if (props?.getValue() === '') {
                setBDisableSaveBtn(true);
                setRangeColor('color-text');
            }
            else {
                if (!props?.getValue().toString().includes('.')) {
                    props.setValue(parseFloat(props.getValue()).toFixed(props.data["SYMBOL"][WATCHLIST_GRID_INDEX.DECIMAL_LOCATOR_LENGTH]));
                }

                if (parseFloat(props?.getValue()) <= 0) {
                    setBDisableSaveBtn(true);
                    setRangeColor('color-error');
                }
                else {
                    if (parseFloat(props?.getValue()) > maxRange || parseFloat(props.getValue()) < minRange) {
                        //  setBDisableSaveBtn(true);
                        setRangeColor('color-error');
                    }
                    else {
                        //BT-106965 : Ordercart :Regression : ManasaB : 26-06-2024 - Start
                        setRangeColor('color-text');
                        if (props.data["ORDER TYPE"] === 'SL') {
                            if (parseFloat(Number(props.data["SL TRIGGER"])) === 0) {
                                setBDisableSaveBtn(true);
                            }
                            else {
                                setBDisableSaveBtn(false);
                                setRangeColor('color-text');
                            }
                        }
                        else {
                            setBDisableSaveBtn(false);
                            setRangeColor('color-text');
                        }
                        //BT-106965 : Ordercart :Regression : ManasaB : 26-06-2024 - End
                    }
                }
            }
        }, [rangeColor, setRangeColor, bDisableSaveBtn]);
        //BT-106965 : Order Cart : ManasaB : 12/03/2024 : Adding Market Depth Value - Start
        const onhandleMarketDepth = useCallback((e, arrActiveScripInformation) => {
            setIsShowMarketDepth(curr => {
                if (!curr && props?.data?.SYMBOL?.length) {
                    dispatch(getExchangeWiseScripInfo(props?.data?.SYMBOL));
                }
                return !curr;
            });
            if (arrActiveScripInformation?.length !== 0) {
                makeGridRowSelected(MULTISCRIP_ORDER_CART_GRID_REF, rowIndex);
                const resitancePivotObj = calculateSupportRestistanceValues(arrActiveScripInformation, 'Classic', '(H+L+C)/3');
                setSupportResistance(resitancePivotObj);
            } else { }
        }, []);
        //BT-106965 : Order Cart : ManasaB : 12/03/2024 : Adding Market Depth Value - End
        const handleIncDec = (name, index) => {
            switch (name) {
                case "subSlLimit":
                    if (props?.getValue() > 0) {
                        props?.setValue((parseFloat(props?.getValue()) - props?.data["SYMBOL"][WATCHLIST_GRID_INDEX.PRICE_TICK])?.toFixed(props?.data["SYMBOL"][WATCHLIST_GRID_INDEX.DECIMAL_LOCATOR_LENGTH]));
                    } else { };
                    break;
                case "addSlLimit": {
                    if (props?.value?.length <= 0) {
                        props?.setValue(props?.data["SYMBOL"][WATCHLIST_GRID_INDEX.PRICE_TICK])?.toFixed(props?.data["SYMBOL"][WATCHLIST_GRID_INDEX.DECIMAL_LOCATOR_LENGTH]);
                        setBDisableSaveBtn(false);
                        break;
                    } else {
                        props?.setValue((parseFloat(props?.getValue()) + props?.data["SYMBOL"][WATCHLIST_GRID_INDEX.PRICE_TICK])?.toFixed(props?.data["SYMBOL"][WATCHLIST_GRID_INDEX.DECIMAL_LOCATOR_LENGTH]));
                        setBDisableSaveBtn(false);
                        break;
                    }

                }
                default:
            }
        };
        return (
            <>
                <div className='d-flex align-items-center justify-content-center pt-2'>
                    <div className={`input-group position-relative ${bDisable ? 'disabled' : ''}`}>
                        <div className={`icon-12 icon-order-decrease input-number-left-wrap ${bDisable && 'div-disabled'}`} onClick={handleIncDec.bind(this, "subSlLimit")}></div>
                        <BzInputText disabled={bDisable} size='sm' type='text' className='font-regular text-center' name="slLimit" onChange={(e) => handleSlLimit(e)} value={props.value} onBlur={handleBlur.bind(this)} />
                        <div className={`icon-12 icon-order-increase input-number-right-wrap ${bDisable && 'div-disabled'}`} onClick={handleIncDec.bind(this, "addSlLimit")}></div>
                    </div>
                    <div className='icon-20 icon-marketdepth ms-2 me-1' onClick={(e) => onhandleMarketDepth(e)}></div>
                </div>
                <div className='font-medium font-size1 color-subtext range-container mt-1'>Range: <span className={`${rangeColor}`}>{props.data["Range"]}</span></div>
            </>
        );
    };

    const SlTriggerComponent = (props) => {
        const { bDisableSaveBtn, setBDisableSaveBtn } = props;
        const { rowIndex } = props?.node;
        const bDisable = !["SL-MKT", "SL"]?.includes(props.data["ORDER TYPE"]);
        let arrRange = props.data["Range"] !== '0.00-0.00' ? props.data["Range"]?.split("-") : [];
        let minRange = arrRange?.length > 0 ? parseFloat(arrRange[0]) : 0;
        let maxRange = arrRange?.length > 0 ? parseFloat(arrRange[1]) : 0;
        const [rangeColor, setRangeColor] = useState('color-text');

        useEffect(() => {
            if (props.data["ORDER TYPE"].includes("SL")) {
                if (parseInt(Number(props.data["SL TRIGGER"])) === 0) {
                    setBDisableSaveBtn(true);
                    setRangeColor('color-error');
                }
                // else{
                //     setBDisableSaveBtn(false)
                //     setRangeColor('color-text')
                // }
            }
            // else{
            //     setBDisableSaveBtn(false)
            // setRangeColor('color-error')
            //  }
        }, [props]); //BT-106965 : Ordercart :Regression : ManasaB : 26-06-2024
        const handleSlTrigger = (e) => {
            e.preventDefault();
            let { value } = e.target;
            value = value?.replace(/[^0-9.]/g, '');
            let decimalCount = value?.split('.').length - 1;
            if (decimalCount > 1) {
                value = value.slice(0, value.lastIndexOf('.'));
            }
            let valueParts = value.split('.');
            if (valueParts[1] && valueParts[1].length > props.data["SYMBOL"][WATCHLIST_GRID_INDEX.DECIMAL_LOCATOR_LENGTH]) {
                value = `${valueParts[0]}.${valueParts[1].slice(0, 2)}`;
            }
            props.setValue(value);
        };
        const handleIncDec = (name, index) => {
            switch (name) {
                case "subSlTrigger":
                    if (props?.getValue() > 0) {
                        props?.setValue((parseFloat(props?.getValue()) - props?.data["SYMBOL"][WATCHLIST_GRID_INDEX.PRICE_TICK])?.toFixed(props?.data["SYMBOL"][WATCHLIST_GRID_INDEX.DECIMAL_LOCATOR_LENGTH]));
                    } else { };
                    break;
                case "addSlTrigger": {
                    if (props?.value?.length <= 0) {
                        props?.setValue(props?.data["SYMBOL"][WATCHLIST_GRID_INDEX.PRICE_TICK])?.toFixed(props?.data["SYMBOL"][WATCHLIST_GRID_INDEX.DECIMAL_LOCATOR_LENGTH]);
                        setBDisableSaveBtn(false);
                        break;
                    } else {
                        props?.setValue((parseFloat(props?.getValue()) + props?.data["SYMBOL"][WATCHLIST_GRID_INDEX.PRICE_TICK])?.toFixed(props?.data["SYMBOL"][WATCHLIST_GRID_INDEX.DECIMAL_LOCATOR_LENGTH]));
                        setBDisableSaveBtn(false);
                        break;
                    }

                }
                default:
            }
        };
        //BT-106965 : Order Cart : ManasaB : 12/03/2024 : Adding Market Depth Value - Start
        const onhandleMarketDepth = useCallback((e, arrActiveScripInformation) => {
            setIsShowMarketDepth(curr => {
                if (!curr && props?.data?.SYMBOL?.length) {
                    dispatch(getExchangeWiseScripInfo(props?.data?.SYMBOL));
                }
                return !curr;
            });
            if (arrActiveScripInformation?.length !== 0) {
                makeGridRowSelected(MULTISCRIP_ORDER_CART_GRID_REF, rowIndex);
                const resitancePivotObj = calculateSupportRestistanceValues(arrActiveScripInformation, 'Classic', '(H+L+C)/3');
                setSupportResistance(resitancePivotObj);
            } else { }
        }, []);
        //BT-106965 : Order Cart : ManasaB : 12/03/2024 : Adding Market Depth Value - End
        const handleBlur = useCallback((e) => {
            e.preventDefault();
            if (props?.getValue() === '') {
                setBDisableSaveBtn(true);
                setRangeColor('color-text');
            }
            else {
                if (!props?.getValue()?.toString()?.includes('.')) {
                    props.setValue(parseFloat(props?.getValue())?.toFixed(props.data["SYMBOL"][WATCHLIST_GRID_INDEX.DECIMAL_LOCATOR_LENGTH]));
                }

                if (parseFloat(Number(props?.getValue())) <= 0) {
                    setBDisableSaveBtn(true);
                    setRangeColor('color-error');
                }
                else {
                    if (parseFloat(props?.getValue()) > maxRange || parseFloat(props?.getValue()) < minRange) {
                        // setBDisableSaveBtn(true);
                        setRangeColor('color-error');
                    }
                    else {
                        //BT-106965 : Ordercart :Regression : ManasaB : 26-06-2024 - Start
                        setRangeColor('color-text');
                        if (props.data["ORDER TYPE"] === 'SL') {
                            if (parseFloat(Number(props.data["SL LIMIT"])) === 0) {
                                setBDisableSaveBtn(true);
                            }
                            else {
                                setBDisableSaveBtn(false);
                                setRangeColor('color-text');
                            }
                        }
                        else {
                            setBDisableSaveBtn(false);
                            setRangeColor('color-text');
                        }
                        //BT-106965 : Ordercart :Regression : ManasaB : 26-06-2024 - End
                    }
                }
            }
        }, [rangeColor, setRangeColor, bDisableSaveBtn]);
        return (
            <>
                <div className='d-flex align-items-center justify-content-center pt-2'>
                    <div className={`input-group position-relative ${bDisable ? 'disabled' : ''}`}>
                        <div className={`icon-12 icon-order-decrease input-number-left-wrap ${bDisable && 'div-disabled'}`} onClick={handleIncDec.bind(this, "subSlTrigger")}></div>
                        <BzInputText disabled={bDisable} size='sm' type='text' className='font-regular text-center' name="slTrigger" onChange={handleSlTrigger.bind(this)} value={props?.value} onBlur={handleBlur.bind(this)} />
                        <div className={`icon-12 icon-order-increase input-number-right-wrap ${bDisable && 'div-disabled'}`} onClick={handleIncDec.bind(this, "addSlTrigger")}></div>
                    </div>
                    <div className='icon-20 icon-marketdepth ms-2 me-1' onClick={(e) => onhandleMarketDepth(e)}></div>
                </div>
                <div className='font-medium font-size1 color-subtext range-container mt-1'>Range: <span className={`${rangeColor}`}>{props.data["Range"]}</span></div>
            </>
        );
    };
    //BT-106965 : Ordercart : SAT1 Issues : ManasaB : 16-04-2024 : Removed row data variable - End
    const CloseIconComponent = (props) => {
        const { setRowData } = props;
        const { rowIndex } = props?.node;
        const onClickCancel = () => {
            //BT-106965 : Ordercart : SAT1 Issues : ManasaB : 16-04-2024  - Start
            if (Object.keys(objSelectedCartRowData).length > 0 || objModalData?.data?.isGoBack) {
                let arrUpdateRowData = [];
                MULTISCRIP_ORDER_CART_GRID_REF?.current?.api?.forEachNode((rowNode, index) => {
                    arrUpdateRowData.push(rowNode?.data);
                });
                if (arrUpdateRowData?.length === 1) {
                    dispatch(toastConfig({ autoDismiss: true, show: true, message: `Atleast one scrip should be present in order cart` }));//BT-106965 : Ordercart : SAT1 Issues : ManasaB : 08-04-2024
                }
                else {
                    let arrCartData = [];
                    MULTISCRIP_ORDER_CART_GRID_REF?.current?.api?.forEachNode((rowNode, index) => {
                        arrCartData.push(rowNode?.data);
                    });
                    arrCartData?.splice(rowIndex, 1);
                    setRowData(deepClone([...arrCartData]));
                    dispatch(storeGridData([...arrCartData]));

                }
            }
            else {
                let arrUpdateRowData = [];
                MULTISCRIP_ORDER_CART_GRID_REF?.current?.api?.forEachNode((rowNode, index) => {
                    arrUpdateRowData.push(rowNode?.data);
                });
                arrUpdateRowData?.splice(rowIndex, 1);
                // MULTISCRIP_ORDER_CART_GRID_REF?.current?.api?.setRowData(arrUpdateRowData); //we are updating grid with updated row data
                dispatch(storeGridData(deepClone([...arrUpdateRowData])));
                setRowData(deepClone([...arrUpdateRowData]));
            }
            //BT-106965 : Ordercart : SAT1 Issues : ManasaB : 16-04-2024  - End

        };
        return (
            <div className='d-flex justify-content-center align-items-center pt-2'>
                <div className='icon-16 icon-close-fill icon-primary' onClick={() => onClickCancel()}></div>
            </div>
        );
    };

    const generateRowData = useCallback(() => {
        let orderDataInfo = [];
        let data = [];
        let arrMarketPriceList = [];
        if (location.pathname === "/ordercart") {

            if (strIdentifyOrderCartMethod === "edit") {
                orderDataInfo = convertEditCart(objSelectedCartRowData?.orders);
            } else if (strIdentifyOrderCartMethod === "create") {
                orderDataInfo = [];
                //BT-106965 : Ordercart : SAT1 Issues : ManasaB : 09-04-2024 - Start
                setRowData([]);
                dispatch(storeGridData([]));
                //BT-106965 : Ordercart : SAT1 Issues : ManasaB : 09-04-2024 - End
            }
        } else {
            orderDataInfo = activeWatchList?.scrips?.filter(ele => {
                if (ele?.[WATCHLIST_GRID_INDEX.INSTRUMENT] === "EQUITIES" && ele?.[WATCHLIST_GRID_INDEX.SERIES] !== 'SM') {//BT-106965 : Ordercart : SAT1 Issues : ManasaB : 10-04-2024
                    return ele;
                }
            });
        }
        const arrScripsForSubscription = orderDataInfo?.map(scrip => ({ exchangeId: getMktSegIdFromMappedMktSegId(scrip[WATCHLIST_GRID_INDEX.MAPPED_SEGMENT_ID]), token: scrip[WATCHLIST_GRID_INDEX.TOKEN], isSubscribe: true }));
        sendTouchlineRequest(arrScripsForSubscription);
        let arrOrderCart = orderDataInfo;
        // BT-106965 : OrderCart: SAT2 : ManasaB : 11-06-2024 - Start  
        //ManasaB : 08-10-2024 : Subscription count : Start
        return new Promise((resolve) => {
            setTimeout(() => {
                const objLastTickData = dispatch(getWfhTouchlineLastTick());
                let strBtn = '';
                let btnColor = '';
                if (activeButtonToggleIndex !== undefined) {
                    if (activeButtonToggleIndex === ORDER_ENTRY_BUTTON_TOGGLE.BUY) {
                        strBtn = 'BUY';
                        btnColor = 'color-positive';
                    }
                    else {
                        strBtn = 'SELL';
                        btnColor = 'color-negative';
                    }
                }
                else {
                    strBtn = 'BUY';
                    btnColor = 'color-positive';
                }
                for (let i = 0; i < arrOrderCart?.length; i++) {
                    const bObjSelectedCartRowData = Object?.keys(objSelectedCartRowData)?.length > 0 && objSelectedCartRowData?.orders[i] !== undefined;
                    let arrLast = objLastTickData[arrOrderCart[i][WATCHLIST_GRID_INDEX?.SEGMENT_ID_TOKEN]];
                    let nRange = arrLast != undefined ? arrLast[TL_INDEX.DAILY_PRICE_RANGE] : "0.00-0.00";
                    let price = bObjSelectedCartRowData ? objSelectedCartRowData?.orders[i]?.LTP : (arrLast?.length > 0 ? arrLast[TL_INDEX?.LAST_TRADE_PRICE] : '0.00');
                    let objMarketPrice = {
                        id: `${arrOrderCart[i][WATCHLIST_GRID_INDEX?.SEGMENT_ID_TOKEN]}_${bObjSelectedCartRowData ? objSelectedCartRowData?.orders[i]?.requestBody?.transaction_type : strBtn}`,
                        price
                    };
                    arrMarketPriceList.push(objMarketPrice);
                    let strProductType = bObjSelectedCartRowData ? objSelectedCartRowData?.orders[i]?.requestBody?.product_type : '';
                    let strConvertedProductType = strProductType !== '' ? `${strProductType?.charAt(0).toUpperCase()}${strProductType?.slice(1).toLowerCase()}` : '';
                    data.push({
                        id: `${arrOrderCart[i][WATCHLIST_GRID_INDEX?.SEGMENT_ID_TOKEN]}_${bObjSelectedCartRowData ? objSelectedCartRowData?.orders[i]?.requestBody?.transaction_type : strBtn}`, //ManasaB : 29/02/2024 :Added trans type to differentiate id
                        'BUY/SELL': bObjSelectedCartRowData ? objSelectedCartRowData?.orders[i]?.requestBody?.transaction_type : strBtn,
                        'SYMBOL': arrOrderCart[i],
                        'EXCHANGE': arrOrderCart[i][WATCHLIST_GRID_INDEX.EXCHANGE],
                        "ORDER TYPE": bObjSelectedCartRowData ? objSelectedCartRowData?.orders[i]?.requestBody?.order_type : "RL-MKT",
                        "VALIDITY": bObjSelectedCartRowData ? objSelectedCartRowData?.orders[i]?.requestBody?.validity : arrOrderCart[i][WATCHLIST_GRID_INDEX.EXCHANGE] == 'NSE' ? "DAY" : 'EOSESS',
                        "QTY": bObjSelectedCartRowData ? objSelectedCartRowData?.orders[i]?.requestBody?.quantity : (arrOrderCart[i][WATCHLIST_GRID_INDEX.REGULAR_LOT] > 0 ? arrOrderCart[i][WATCHLIST_GRID_INDEX.REGULAR_LOT] : 1),
                        "PRICE": bObjSelectedCartRowData ? objSelectedCartRowData?.orders[i]?.LTP : (arrLast?.length > 0 ? arrLast[TL_INDEX?.LAST_TRADE_PRICE] : '0.00'), //Manasa :  19/03/2024 : After discussion with Samadhan changed
                        "PROD TYPE": bObjSelectedCartRowData ? strConvertedProductType : objDefaultProductType.sDescription,
                        "SL LIMIT": bObjSelectedCartRowData ? (objSelectedCartRowData?.orders[i]?.requestBody?.order_type === 'SL' ? objSelectedCartRowData?.orders[i]?.requestBody?.price : '0.00') : '0.00',
                        "SL TRIGGER": bObjSelectedCartRowData ? objSelectedCartRowData?.orders[i]?.requestBody?.trigger_price : '0.00',
                        "AMO": bObjSelectedCartRowData ? objSelectedCartRowData?.orders[i]?.requestBody?.is_amo : false,
                        "BtnColor": bObjSelectedCartRowData ? (objSelectedCartRowData?.orders[i]?.requestBody?.transaction_type === 'BUY' ? 'color-positive' : 'color-negative') : btnColor,
                        "Range": parseFloat(Number(arrOrderCart[i][WATCHLIST_GRID_INDEX.DAILY_PRICE_RANGE])) !== 0 ? arrOrderCart[i][WATCHLIST_GRID_INDEX.DAILY_PRICE_RANGE] : nRange,
                        "amoUpdated": false
                    });
                }
                //ManasaB : 08-10-2024 : Subscription count : End
                resolve(data);
                setArrMarketPrice(arrMarketPriceList);
                dispatch(getOrderMarketPriceList(arrMarketPriceList));
            }, 100);
        });
        //BT-106965 : OrderCart: SAT2 : ManasaB : 11-06-2024 - End
    }, [dispatch, activeButtonToggleIndex, activeWatchList?.scrips, location.pathname, objSelectedCartRowData, strIdentifyOrderCartMethod]);
    useEffect(() => {
        if (layoutType == LAYOUT_TYPE.HORIZONTAL) { //BREEZE-305 :Watchlist Side tray- Order Cart Order entry :ManasaB : 20-11-2024 : SAT issues  
            if (Object.keys(objModalData).length === 0) {
                generateRowData()?.then((data) => {
                    let arrGeneratedOrderData = data;
                    dispatch(storeGridData(arrGeneratedOrderData)); //BT-106965 : Ordercart : SAT1 Issues : ManasaB : 18-04-2024  : Security Measures
                    setArrMarketPrice([...arrOrderCartMarketPriceData])
                    setRowData(arrGeneratedOrderData);
                });
            }
            else if (Object.keys(objModalData).length > 0 && objModalData?.data?.isGoBack === false) {
                generateRowData()?.then((data) => {
                    let arrGeneratedOrderData = data;
                    dispatch(storeGridData(arrGeneratedOrderData)); //BT-106965 : Ordercart : SAT1 Issues : ManasaB : 18-04-2024 Security Measures
                    setArrMarketPrice([...arrOrderCartMarketPriceData])
                    setRowData(arrGeneratedOrderData);
                });
            }
            else if (Object.keys(objModalData).length > 0 && objModalData?.data?.isSurvMeasureRejected) {
                setArrMarketPrice([...arrOrderCartMarketPriceData])
                setRowData(deepClone([...arrData]));
                dispatch(storeGridData(deepClone([...arrData])));// BT-106965 : OrderCart: SAT2 : ManasaB : 17-05-2024 
            }
            else {
                if (arrData?.length > 0) {
                    //BT-106965 : Ordercart : SAT1 Issues : ManasaB : 08-04-2024  - Start
                    //BT-106965 : Ordercart : SAT1 Issues : ManasaB : 18-04-2024 : Security Measures - Start
                    if (objModalData?.data?.isGoback) {
                        setIsGoBackConfirm(true);
                    }
                    //BT-106965 : Ordercart : SAT1 Issues : ManasaB : 18-04-2024 : Security Measures - End
                    setStrCartName(objSavedCartDetails.cartName);
                    setStrCartId(objSavedCartDetails.cartId);
                    //BT-106965 : Ordercart : SAT1 Issues : ManasaB : 08-04-2024 - End
                    // BT-106965 : OrderCart: SAT2 : ManasaB : 17-05-2024 - Start
                    setArrMarketPrice([...arrOrderCartMarketPriceData])
                    setRowData(deepClone([...arrData]));
                    dispatch(storeGridData(deepClone([...arrData])));
                    dispatch(saveCartSuccess(false));
                    // BT-106965 : OrderCart: SAT2 : ManasaB : 17-05-2024 - End
                }
            }
        }
    }, [objSavedCartDetails]);

    //BT-106965 : Order Cart : Side Tray : ManasaB : 23-07-2024 - Start
    const generateVerticalData = () => {
        let orderDataInfo = [];
        let data = [];
        let arrMarketPriceList = [];
        orderDataInfo = activeWatchList?.scrips?.filter(ele => {
            if (ele?.[WATCHLIST_GRID_INDEX.INSTRUMENT] === "EQUITIES" && ele?.[WATCHLIST_GRID_INDEX.SERIES] !== 'SM') {//BT-106965 : Ordercart : SAT1 Issues : ManasaB : 10-04-2024
                return ele;
            }
        });
        const arrScripsForSubscription = orderDataInfo?.map(scrip => ({ exchangeId: getMktSegIdFromMappedMktSegId(scrip[WATCHLIST_GRID_INDEX.MAPPED_SEGMENT_ID]), token: scrip[WATCHLIST_GRID_INDEX.TOKEN], isSubscribe: true }));
        sendTouchlineRequest(arrScripsForSubscription);
        let objProdType = productTypes && productTypes?.length > 0 && productTypes?.find(eachProd => eachProd.sDefaultProductType == ORDER_PRODUCT_TYPES.DELIVERY);
        //ManasaB : 08-10-2024 : Subscription count : Start
        return new Promise((resolve) => {
            setTimeout(() => {
                const objLastTickData = dispatch(getWfhTouchlineLastTick());
                let strBtn = 'BUY';
                let btnColor = 'color-positive';
                for (let i = 0; i < orderDataInfo?.length; i++) {
                    let arrLast = objLastTickData[orderDataInfo[i][WATCHLIST_GRID_INDEX?.SEGMENT_ID_TOKEN]];
                    let nRange = arrLast != undefined ? arrLast[TL_INDEX.DAILY_PRICE_RANGE] : '0.00 - 0.00';
                    let price = (arrLast?.length > 0 ? arrLast[TL_INDEX?.LAST_TRADE_PRICE] : '0.00');
                    let objMarketPrice = {
                        id: `${orderDataInfo[i][WATCHLIST_GRID_INDEX?.SEGMENT_ID_TOKEN]}_ ${strBtn}`,
                        price
                    };
                    arrMarketPriceList.push(objMarketPrice);
                    data.push({
                        id: `${orderDataInfo[i][WATCHLIST_GRID_INDEX?.SEGMENT_ID_TOKEN]}_ ${strBtn}`, //ManasaB : 29/02/2024 :Added trans type to differentiate id
                        'BUY/SELL': strBtn,
                        'SYMBOL': orderDataInfo[i],
                        'EXCHANGE': orderDataInfo[i][WATCHLIST_GRID_INDEX.EXCHANGE],
                        "ORDER TYPE": "RL-MKT",
                        "VALIDITY": orderDataInfo[i][WATCHLIST_GRID_INDEX.EXCHANGE] == 'NSE' ? "DAY" : 'EOSESS',
                        "QTY": 1,
                        "PRICE": (arrLast?.length > 0 ? arrLast[TL_INDEX?.LAST_TRADE_PRICE] : '0.00'), //Manasa :  19/03/2024 : After discussion with Samadhan changed
                        "PROD TYPE": objDefaultProductType.sDescription,
                        "SL LIMIT": '0.00',
                        "SL TRIGGER": '0.00',
                        "AMO": false,
                        "BtnColor": btnColor,
                        "Range": nRange,
                        "ActiveButtonToggleIndex": 0,
                        "amoUpdated": false,
                        //  "bIsEditEnable" : false
                    });
                }
                //ManasaB : 08-10-2024 : Subscription count : End
                resolve(data);
                setArrMarketPrice(arrMarketPriceList);
                dispatch(getOrderMarketPriceList(arrMarketPriceList));
            }, 100);
        });

    };
    useEffect(() => {
        return () => {
            if (layoutType === LAYOUT_TYPE.HORIZONTAL) {
                let arrRowData = [...rowData];
                const arrScripsForUnSubscription = arrRowData?.map(scrip => ({ exchangeId: getMktSegIdFromMappedMktSegId(scrip[WATCHLIST_GRID_INDEX.MAPPED_SEGMENT_ID]), token: scrip[WATCHLIST_GRID_INDEX.TOKEN], isSubscribe: false }));
                sendTouchlineRequest(arrScripsForUnSubscription);
            }
            else if (layoutType === LAYOUT_TYPE.VERTICAL) {
                let arrRowData = [...arrScripsData];
                const arrScripsForUnSubscription = arrRowData?.map(scrip => ({ exchangeId: getMktSegIdFromMappedMktSegId(scrip[WATCHLIST_GRID_INDEX.MAPPED_SEGMENT_ID]), token: scrip[WATCHLIST_GRID_INDEX.TOKEN], isSubscribe: false }));
                sendTouchlineRequest(arrScripsForUnSubscription);
            }
        };
    }, []);
    useEffect(() => {
        //BREEZE-305 :Watchlist Side tray- Order Cart Order entry :ManasaB : 20-11-2024 : SAT issues - Start
        if (layoutType === LAYOUT_TYPE.VERTICAL && !bIsConfirmBack && !bIsSaveCartBack) {
            if (arrOrderBackupData?.length === 0) {
                generateVerticalData()?.then(response => {
                    let arrData = response;
                    setArrScripsData([...arrData]);
                    dispatch(getOrderDataBackupVertical([...arrData]));
                });
            }
            else {
                setArrMarketPrice([...arrOrderCartMarketPriceData])
                setArrScripsData([...arrOrderBackupData]);
            }
        }
        //BREEZE-305 :Watchlist Side tray- Order Cart Order entry :ManasaB : 20-11-2024 : SAT issues - End
    }, [activeWatchList, bIsConfirmBack]);
    //BT-106965 : Order Cart : Side Tray : ManasaB : 23-07-2024 - End
    useEffect(() => {
        if (strIdentifyOrderCartMethod === undefined && objModalData?.data?.isGoBack === false) { //BT-106965  : OrderCart : SAT2 Issues : 03-05-2024
            setStrCartName('');
        }
    }, [strIdentifyOrderCartMethod, strCartName]);
    const handleMarginInfo = useCallback((arrOrderInfo) => {
        calculatedAndGetOrderMarginInfoFor(arrOrderInfo);
    }, []);

    useEffect(() => {
        //BT-106965 : Ordercart : SAT2 Issues : ManasaB : 03-06-2024 : Start
        if (rowData?.length > 0) {
            const arrRowData = [...rowData];
            const arrSymbolInfo = arrRowData?.map(eachData => {
                return eachData["SYMBOL"];
            });
            setArrSymbolData(arrSymbolInfo);
        }
        //BT-106965 : Ordercart : SAT2 Issues : ManasaB : 03-06-2024 : End
    }, [rowData]);
    const columnDefs = useMemo(() => {
        //BT-106965 : OrderCart: SAT2 : ManasaB : 11-06-2024 - Start
        return [
            {
                field: "BUY/SELL", suppressMovable: true,
                suppressNavigable: true, cellRenderer: BuySellDropDown, cellRendererParams: { rowData, setRowData }, minWidth: 100, resizable: false, sortable: false, menuTabs: []
            },
            {
                field: "SYMBOL", suppressMovable: true,
                suppressNavigable: true, cellRenderer: SymbolComponent, cellRendererParams: { rowData, setRowData }, minWidth: 80, resizable: false, sortable: false, menuTabs: []
            },
            {
                field: "EXCHANGE", suppressMovable: true,
                suppressNavigable: true, cellRenderer: ExchangeDropDown, cellRendererParams: { rowData, setRowData }, minWidth: 50, resizable: false, sortable: false, menuTabs: []
            },
            {
                field: "PROD TYPE", suppressMovable: true,
                suppressNavigable: true, cellRenderer: ProductTypeDropDownComponent, cellRendererParams: { rowData, setRowData, arrProdTypes }, minWidth: 50, resizable: false, sortable: false, menuTabs: []
            },
            {
                field: "ORDER TYPE", suppressMovable: true,
                suppressNavigable: true, cellRenderer: OrderTypeDropDown, cellRendererParams: { rowData, setRowData, setBDisableSaveBtn }, minWidth: 50, resizable: false, sortable: false, menuTabs: []
            },
            {
                field: "QTY", suppressMovable: true,
                suppressNavigable: true, cellRenderer: QuantityComponent, cellRendererParams: { rowData, setRowData }, minWidth: 150, resizable: false, sortable: false, menuTabs: []  //ManasaB:30-09-2024 : Solved ui adjustment issue from smoketesting
            },
            {
                field: "PRICE", suppressMovable: true,
                suppressNavigable: true, cellRenderer: PriceComponent, cellRendererParams: { rowData, setRowData, bDisableSaveBtn, setBDisableSaveBtn }, minWidth: 250, resizable: false, sortable: false, menuTabs: []
            },
            {
                field: "SL TRIGGER", suppressMovable: true,
                suppressNavigable: true, cellRenderer: SlTriggerComponent, cellRendererParams: { rowData, setRowData, bDisableSaveBtn, setBDisableSaveBtn }, minWidth: 250, resizable: false, sortable: false, menuTabs: []
            },
            {
                field: "SL LIMIT", suppressMovable: true,
                suppressNavigable: true, cellRenderer: SlLimitComponent, cellRendererParams: { rowData, setRowData, bDisableSaveBtn, setBDisableSaveBtn }, minWidth: 250, resizable: false, sortable: false, menuTabs: []
            },
            {
                field: "VALIDITY", suppressMovable: true,
                suppressNavigable: true, cellRenderer: ValidityDropDown, cellRendererParams: { rowData, setRowData }, minWidth: 120, resizable: false, sortable: false, menuTabs: []
            },
            {
                headerName: 'AMO', suppressMovable: true,
                suppressNavigable: true, field: 'AMO', cellRenderer: AmoComponent, cellRendererParams: { rowData, setRowData, marketStatus }, minWidth: 80, resizable: false, sortable: false, menuTabs: []
            },
            {
                field: '', headerName: '', suppressMovable: true,
                suppressNavigable: true, cellRenderer: CloseIconComponent, pinned: 'right', cellRendererParams: { rowData, setRowData, setGlobalScripDetails }, sortable: false, menuTabs: []
            }
        ];
        //BT-106965 : OrderCart: SAT2 : ManasaB : 11-06-2024 - End
    }, [rowData, marketStatus]);

    const checkBuyExisting = (scrip) => {  // ManasaB : 08-01-2025 : Disabling Buy when same scrip is already present in search list
        let arrGridData = [];
        if (layoutType === LAYOUT_TYPE.HORIZONTAL) {
            arrGridData = [...rowData];
        }
        else {
            arrGridData = [...arrScripsData];
        }
        const bIsExist = arrGridData.some(eachData => eachData["SYMBOL"][WATCHLIST_GRID_INDEX.SEGMENT_ID_TOKEN] === scrip[WATCHLIST_GRID_INDEX.SEGMENT_ID_TOKEN] && eachData["BUY/SELL"] === 'BUY' ? true : false);
        return bIsExist;
    }; // ManasaB : 08-01-2025 : Disabling Buy when same scrip is already present in search list
    const checkSellExisting = (scrip) => {
        let arrGridData = [];
        if (layoutType === LAYOUT_TYPE.HORIZONTAL) {
            arrGridData = [...rowData];
        }
        else {
            arrGridData = [...arrScripsData];
        }
        const bIsExist = arrGridData.some(eachData => eachData["SYMBOL"][WATCHLIST_GRID_INDEX.SEGMENT_ID_TOKEN] === scrip[WATCHLIST_GRID_INDEX.SEGMENT_ID_TOKEN] && eachData["BUY/SELL"] === 'SELL' ? true : false);
        return bIsExist;
    };
    const handleArrAgGridRowData = useCallback((arrTouchLineData) => {
        const arrUpdatedRowData = [...rowData];
        let aIndex = arrUpdatedRowData?.findIndex((eachScrip) => (getMktSegIdFromMappedMktSegId(eachScrip?.SYMBOL[WATCHLIST_GRID_INDEX?.MAPPED_SEGMENT_ID]) + '_' + eachScrip?.SYMBOL[WATCHLIST_GRID_INDEX?.TOKEN] === arrTouchLineData[TL_INDEX?.SEGMENT_ID] + '_' + arrTouchLineData[TL_INDEX?.TOKEN]));
        if (aIndex >= 0) {

            const arrScripToBeUpdated = arrUpdatedRowData[aIndex];
            let arrUpdatedScrips = arrScripToBeUpdated['SYMBOL'];
            arrUpdatedScrips[WATCHLIST_GRID_INDEX.LAST_TRADE_PRICE] = arrTouchLineData[TL_INDEX.LAST_TRADE_PRICE];
            arrUpdatedScrips[WATCHLIST_GRID_INDEX.LTP_PERCENT] = arrTouchLineData[TL_INDEX.NET_CHANGE_FROM_PRE_CLOSE];
            arrUpdatedScrips[WATCHLIST_GRID_INDEX.CHANGE_IN_LTP] = arrTouchLineData[TL_INDEX.ABSOLUTE_NET_CHANGE_FROM_PRE_CLOSE];
            arrUpdatedScrips[WATCHLIST_GRID_INDEX.BID_PRICE] = arrTouchLineData[TL_INDEX.BUY_PRICE];
            arrUpdatedScrips[WATCHLIST_GRID_INDEX.BID_PRICE_INDICATOR] = arrTouchLineData[TL_INDEX.BUY_PRICE_INDICATOR];
            arrUpdatedScrips[WATCHLIST_GRID_INDEX.NET_CHANGE_INDICATOR] = arrTouchLineData[TL_INDEX.NET_CHANGE_INDICATOR];
            arrUpdatedScrips[WATCHLIST_GRID_INDEX.BID_QUANTITY] = arrTouchLineData[TL_INDEX.BUY_QTY];
            arrUpdatedScrips[WATCHLIST_GRID_INDEX.ASK_PRICE] = arrTouchLineData[TL_INDEX.SELL_PRICE];
            arrUpdatedScrips[WATCHLIST_GRID_INDEX.ASK_PRICE_INDICATOR] = arrTouchLineData[TL_INDEX.SELL_PRICE_INDICATOR];
            arrUpdatedScrips[WATCHLIST_GRID_INDEX.ASK_QTY] = arrTouchLineData[TL_INDEX.SELL_QTY];
            arrUpdatedScrips[WATCHLIST_GRID_INDEX.HIGH] = arrTouchLineData[TL_INDEX.HIGH_PRICE];
            arrUpdatedScrips[WATCHLIST_GRID_INDEX.LOW] = arrTouchLineData[TL_INDEX.LOW_PRICE];
            arrUpdatedScrips[WATCHLIST_GRID_INDEX.OPEN] = arrTouchLineData[TL_INDEX.OPEN_PRICE];
            arrUpdatedScrips[WATCHLIST_GRID_INDEX.CLOSE] = arrTouchLineData[TL_INDEX.CLOSE_PRICE];
            arrUpdatedScrips[WATCHLIST_GRID_INDEX.VOLUME] = arrTouchLineData[TL_INDEX.VOLUME];
            arrUpdatedScrips[WATCHLIST_GRID_INDEX.ATP] = arrTouchLineData[TL_INDEX.AVG_TRADED_PRICE];
            arrUpdatedScrips[WATCHLIST_GRID_INDEX.TOKEN] = arrTouchLineData[TL_INDEX.TOKEN];
            arrScripToBeUpdated['SYMBOL'] = arrUpdatedScrips;
            MULTISCRIP_ORDER_CART_GRID_REF?.current?.api.applyTransaction({
                update: [arrScripToBeUpdated]
            });
        } else { }
    }, [rowData]);
    useEffect(() => {
        if (rowData?.length > 0) {
            const objLastTickData = dispatch(getWfhTouchlineLastTick());
            rowData.forEach(eachData => {
                const arrLastTickScripData = objLastTickData[eachData["SYMBOL"][WATCHLIST_GRID_INDEX.SEGMENT_ID_TOKEN]];
                if (arrLastTickScripData?.length > 0) {
                    handleArrAgGridRowData([...arrLastTickScripData]);
                } else { }
            });

        } else { }
        return () => {
            const arrDistinctScripExchangesSubscription = rowData?.map(eachData => ({ exchangeId: eachData["SYMBOL"][WATCHLIST_GRID_INDEX.SEGMENT_ID], token: eachData["SYMBOL"][WATCHLIST_GRID_INDEX.TOKEN], isSubscribe: true }));
            sendTouchlineRequest(arrDistinctScripExchangesSubscription);
        };

    }, [rowData, dispatch]);

    useWFHMessages('touchline', (e) => {
        // handleArrGridRowData([...e.detail]);
        handleArrAgGridRowData([...e.detail]);
    });

    const BrokerageChargesModal = () => {
        dispatch(handleModal([{ 'BROKERAGE_MULTILEG': true }]));//BT-126347 : Brokerage and Statutory changes - Order Cart : ManasaB : 19/01/2024 
    };

    //To get( LTP & LTP&  & Change in LTP) from WFH to newly added EQ Scrip From Search
    const handleMarketDataForScrips = useCallback((touchlineData) => {
        const addedScrips = scripAddedInfo;
        let nindex = addedScrips.findIndex(eachIndex => eachIndex[WATCHLIST_GRID_INDEX.SEGMENT_ID] === touchlineData[TL_INDEX.SEGMENT_ID] && eachIndex[WATCHLIST_GRID_INDEX.TOKEN] === touchlineData[TL_INDEX.TOKEN]);
        if (nindex >= 0 && addedScrips[nindex][WATCHLIST_GRID_INDEX.LAST_TRADE_PRICE] === "") {
            addedScrips[nindex][WATCHLIST_GRID_INDEX.LAST_TRADE_PRICE] = touchlineData[TL_INDEX.LAST_TRADE_PRICE];
            addedScrips[nindex][WATCHLIST_GRID_INDEX.LTP_PERCENT] = touchlineData[TL_INDEX.NET_CHANGE_FROM_PRE_CLOSE];

            addedScrips[nindex][WATCHLIST_GRID_INDEX.CHANGE_IN_LTP] = touchlineData[TL_INDEX.ABSOLUTE_NET_CHANGE_FROM_PRE_CLOSE];
            setGlobalScripDetails([...addedScrips]);
        }
    }, [globalScripDetails, scripAddedInfo]);
    //To GET WFH data
    useWFHMessages('touchline', (e) => {
        handleMarketDataForScrips(e.detail);
    });
    const onBuySellClick = useCallback((strBuySell, scrip) => {
        //BT-106965 : Ordercart : SAT2 Issues : ManasaB : 03-06-2024 : To restrict scrips SM scrips - Start
        let arrMarketPriceList = [];
        if (scrip?.[WATCHLIST_GRID_INDEX.INSTRUMENT] === "EQUITIES" && scrip?.[WATCHLIST_GRID_INDEX.SERIES] != 'SM') {//BT-106965 : Ordercart : SAT1 Issues : ManasaB : 10-04-2024
            setIsFlag(1);
            //  setOrderBookSearchModal(false);
            setStrSearchInputText('');
            sendTouchlineRequest([
                { exchangeId: scrip[WATCHLIST_GRID_INDEX?.SEGMENT_ID]?.length != 0 ? scrip[WATCHLIST_GRID_INDEX?.SEGMENT_ID] : 0, token: scrip[WATCHLIST_GRID_INDEX?.TOKEN]?.length != 0 ? scrip[WATCHLIST_GRID_INDEX?.TOKEN] : 0 },
            ]);

            setTimeout(() => {
                const arrUpdatedRowData = layoutType == LAYOUT_TYPE.HORIZONTAL ? [...rowData] : arrScripsData;
                //BT-106965 : Ordercart : SAT1 Issues : ManasaB : 02-04-2024 : To restrict scrips if exceeds count - Start
                if (arrUpdatedRowData.length < nOrderCartCount) {
                    let btnColor = '';
                    if (strBuySell.toUpperCase() == 'BUY') {
                        btnColor = 'color-positive';
                    }
                    else {
                        btnColor = 'color-negative';
                    }
                    let strBUYSELL = strBuySell.toUpperCase();
                    const objLastTickData = dispatch(getWfhTouchlineLastTick());
                    let arrScrip = objLastTickData[scrip[WATCHLIST_GRID_INDEX?.SEGMENT_ID_TOKEN]];
                    let nRange = arrScrip != undefined ? arrScrip[TL_INDEX.DAILY_PRICE_RANGE] : '0.00 - 0.00';
                    let price = arrScrip?.length > 0 ? arrScrip[TL_INDEX?.LAST_TRADE_PRICE] : '0.00';
                    let objMarketPrice = {
                        id: `${scrip[WATCHLIST_GRID_INDEX?.SEGMENT_ID_TOKEN]}_${strBUYSELL}`,
                        price
                    };
                    arrMarketPriceList.push(objMarketPrice);
                    const objScrip = {
                        id: `${scrip[WATCHLIST_GRID_INDEX?.SEGMENT_ID_TOKEN]}_${strBUYSELL}`, //ManasaB : 29/02/2024 : Added trans type to differentiate id
                        'BUY/SELL': strBuySell.toUpperCase(),
                        'SYMBOL': scrip, 'EXCHANGE': scrip[WATCHLIST_GRID_INDEX.EXCHANGE],
                        "ORDER TYPE": "RL-MKT",
                        "VALIDITY": scrip[WATCHLIST_GRID_INDEX.EXCHANGE] == 'NSE' ? "DAY" : 'EOSESS',
                        "QTY": scrip[WATCHLIST_GRID_INDEX.REGULAR_LOT] > 0 ? scrip[WATCHLIST_GRID_INDEX.REGULAR_LOT] : 1,
                        "PRICE": arrScrip?.length > 0 ? arrScrip[TL_INDEX?.LAST_TRADE_PRICE] : '0.00',
                        "PROD TYPE": objDefaultProductType.sDescription,
                        "SL LIMIT": '0.00', "SL TRIGGER": '0.00',
                        'AMO': false, 'BtnColor': btnColor,
                        "Range": scrip[WATCHLIST_GRID_INDEX.DAILY_PRICE_RANGE] != 0 ? scrip[WATCHLIST_GRID_INDEX.DAILY_PRICE_RANGE] : nRange,
                        "ActiveButtonToggleIndex": strBuySell.toUpperCase() == 'BUY' ? 0 : 1,
                        amoUpdated: false

                    };
                    if (objScrip[WATCHLIST_GRID_INDEX.SEGMENT_ID_TOKEN] != scrip[WATCHLIST_GRID_INDEX.SEGMENT_ID_TOKEN]) {
                        setScripAddedInfo(curr => [...curr, scrip]);
                        setGlobalScripDetails(curr => [...curr, scrip]);
                    }
                    if (checkGSM == FACILITY_STR.ON && scrip[WATCHLIST_GRID_INDEX.SURV_MEASURE_DESCRIPTION] != null) {
                        let objSurvMeasure = {
                            marketSegmentId: scrip[WATCHLIST_GRID_INDEX.EXCHANGE_SEGMENT],
                            token: scrip[WATCHLIST_GRID_INDEX.TOKEN],
                            cautionaryText: scrip[WATCHLIST_GRID_INDEX.SURV_MEASURE_DESCRIPTION],
                            textString: `${scrip[WATCHLIST_GRID_INDEX.EXCHANGE]} ${scrip[WATCHLIST_GRID_INDEX.SYMBOL]} ${scrip[WATCHLIST_GRID_INDEX.SERIES]} <br>  Graded Surveillance Measure <br> ${scrip[WATCHLIST_GRID_INDEX.SURV_MEASURE_DESCRIPTION]}`
                        };
                        //  arrSurvMeasuresData.push(`${scrip[WATCHLIST_GRID_INDEX.EXCHANGE]} ${scrip[WATCHLIST_GRID_INDEX.SYMBOL]} ${eachHoldingScrip[WATCHLIST_GRID_INDEX.SERIES]} Graded Surveillance Measure ${eachHoldingScrip["SYMBOL"][WATCHLIST_GRID_INDEX.SURV_MEASURE_DESCRIPTION]}`);
                        setArrSurvMeasureData(curr => [...curr, objSurvMeasure]);
                    }
                    arrUpdatedRowData.push(objScrip);
                    setArrMarketPrice(arrMarketPriceList);
                    dispatch(getOrderMarketPriceList(arrMarketPriceList));
                    if (layoutType == LAYOUT_TYPE.HORIZONTAL) {
                        MULTISCRIP_ORDER_CART_GRID_REF?.current?.api?.applyTransaction({
                            update: [arrUpdatedRowData]
                        });
                        setRowData([...arrUpdatedRowData]);
                        dispatch(storeGridData([...arrUpdatedRowData]));// BT-106965 : OrderCart: SAT2 : ManasaB : 17-05-2024 

                    }
                    else {
                        let arrScripsBeforeAdd = [...arrScripsData];
                        calculatedAndGetOrderMarginInfoFor(arrUpdatedRowData); //ManasaB : 17-10-2024 : Fixed infinite api call for getOrderMarginInfo api for side tray order cart
                        setArrScripsData([...arrUpdatedRowData]);
                        dispatch(getOrderDataBackupVertical([...arrUpdatedRowData]));
                    }
                }
                else {
                    dispatch(setShowSideTrayPlaceOrder(true));
                    dispatch((toastConfig({ autoDismiss: true, show: true, message: `You can not add more than ${nOrderCartCount} in single cart.` })));
                }
            }, 200);
        }
        else {
            dispatch((toastConfig({ autoDismiss: true, show: true, message: 'Currently Equity orders are allowed to add in cart.Please choose another order.' })));
        }
        //BT-106965 : Ordercart : SAT2 Issues : ManasaB : 03-06-2024 : To restrict scrips SM scrips - End
        //BT-106965 : Ordercart : SAT1 Issues : ManasaB : 02-04-2024 : To restrict scrips if exceeds count - End
    }, [rowData, scripAddedInfo, dispatch, arrScripsData, bIsPlaceOrderBtnDisabled]);
    //To Add EQscript only form search tab & to check Script is already present or not
    const addGlobalScrips = useCallback((e, scrip) => {
        setIsFlag(1);
        setOrderBookSearchModal(false);
        setStrSearchInputText('');
        sendTouchlineRequest([
            { exchangeId: scrip[WATCHLIST_GRID_INDEX?.SEGMENT_ID]?.length != 0 ? scrip[WATCHLIST_GRID_INDEX?.SEGMENT_ID] : 0, token: scrip[WATCHLIST_GRID_INDEX?.TOKEN]?.length != 0 ? scrip[WATCHLIST_GRID_INDEX?.TOKEN] : 0 },
        ]);
        let arrUpdatedRowData = [];
        MULTISCRIP_ORDER_CART_GRID_REF?.current?.api?.forEachNode((rowNode, index) => {
            arrUpdatedRowData.push(rowNode?.data);;
        });
        let btnColor = 'color-positive';
        const objLastTickData = dispatch(getWfhTouchlineLastTick());
        let arrScrip = objLastTickData[scrip[WATCHLIST_GRID_INDEX?.SEGMENT_ID_TOKEN]];
        const objScrip = {
            id: scrip[WATCHLIST_GRID_INDEX?.SEGMENT_ID_TOKEN],
            'BUY/SELL': 'BUY', 'SYMBOL': scrip, 'EXCHANGE': scrip[WATCHLIST_GRID_INDEX.EXCHANGE], "ORDER TYPE": "RL-MKT",
            "VALIDITY": "DAY", "QTY": 1, "PRICE": arrScrip?.length > 0 ? arrScrip[TL_INDEX?.LAST_TRADE_PRICE] : 0,
            "PROD TYPE": objDefaultProductType.sDescription, "SL LIMIT": 0, "SL TRIGGER": 0,
            'AMO': false, 'BtnColor': btnColor

        };
        if (objScrip[WATCHLIST_GRID_INDEX.SEGMENT_ID_TOKEN] != scrip[WATCHLIST_GRID_INDEX.SEGMENT_ID_TOKEN]) {
            setScripAddedInfo(curr => [...curr, scrip]);
            setGlobalScripDetails(curr => [...curr, scrip]);
        }
        arrUpdatedRowData.push(objScrip);
        //  setRowData([...arrUpdatedRowData]);
    }, [rowData, scripAddedInfo]);

    const onChangeTabSearch = (e) => {
        const { name, value } = e.target;
        setStrSearchInputText(value);
        setOrderBookSearchModal(true);
        //ManasaB : 23-09-2024 : Ordercart Infinite loop issue - Start
        if (value && value.length >= GLOBAL_SEARCH_MIN_LENGTH) {
            // eslint-disable-next-line react-hooks/rules-of-hooks
            useDebounce(() => {
                dispatch(getSearchScripsEquity(value?.toUpperCase(), -1, 0, 25));
            }, 1000);
        }
        //ManasaB : 23-09-2024 : Ordercart Infinite loop issue - End
    };
    //To Remove Scrip from ordercart
    const onHandledelete = useCallback((event, scrip) => {
        setIsFlag(0);
        let arrCartData = [...rowData];
        let nIndex = arrCartData.findIndex(eachData => eachData["SYMBOL"][WATCHLIST_GRID_INDEX.SEGMENT_ID_TOKEN] == scrip[WATCHLIST_GRID_INDEX.SEGMENT_ID_TOKEN]);
        if (nIndex >= 0) {
            arrCartData.splice(nIndex, 1);
            MULTISCRIP_ORDER_CART_GRID_REF.current.api.setRowData(arrCartData);
            setRowData([...arrCartData]);
        }
        setGlobalScripDetails(curr => {
            const arrCurrScripDetails = curr;
            const nIndex = arrCurrScripDetails.findIndex(each => each[WATCHLIST_GRID_INDEX.SEGMENT_ID_TOKEN] === scrip[WATCHLIST_GRID_INDEX.SEGMENT_ID_TOKEN]);
            if (nIndex >= 0) {
                arrCurrScripDetails.splice(nIndex, 1);
            } else { }
            return [...arrCurrScripDetails];
        });
        //  setOrderBookSearchModal(false);

    }, [rowData, globalScripDetails, orderCartInfo]);
    useEffect(() => {
        //BT-106965 : Ordercart : SAT2 Issues : ManasaB : 03-06-2024 : Start
        if (rowData?.length > 0) {
            const arrOrderCartData = [...rowData];
            if (arrOrderCartData.length == 0) {
                setBDisableSaveBtn(true);
            }
            else {
                setBDisableSaveBtn(false);
            }
        }
        //BT-106965 : Ordercart : SAT2 Issues : ManasaB : 03-06-2024 :End
    }, [rowData]);
    //BT-106965 : Ordercart : SAT1 Issues : ManasaB : 18-04-2024 Security Measure - Start
    useEffect(() => {
        if (isSurvMeasure) {
            dispatch(handleModal([{ 'SURV_MEASURE': true }]));
        }
        else {
            //BT-106965 : Order Cart : Cart name modal issue : ManasaB : 23-07-2024 - Start
            //objModalData?.data &&
            if (Object.keys(objModalData)?.includes('data')) {
                //ManasaB:03-SEP-24 :Not opening save modal - Start
                if (Object.keys(objModalData?.data)?.includes('isSurvMeasureAccepted')) {
                    if (objModalData?.data?.isSurvMeasureAccepted) {
                        saveCartData();
                    }
                }
                //ManasaB:03-SEP-24 :Not opening save modal - End
            }
            else {

            }
            //BT-106965 : Order Cart : Cart name modal issue : ManasaB : 23-07-2024 - End
        }
    }, [isSurvMeasure]);
    const saveCartData = () => {
        //BT-106965 : OrderCart - SideTray : ManasaB : 29-07-2024 : Security measure issue - Start
        let arrOrderCartData = [];
        //dispatch(handleModalData({}));
        if (layoutType == LAYOUT_TYPE.HORIZONTAL) {
            MULTISCRIP_ORDER_CART_GRID_REF?.current?.api?.forEachNode((rowNode, index) => {
                arrOrderCartData.push(rowNode?.data);
            });
        }
        else {
            setIsSurvMeasure(false);
            // dispatch(setShowSideTrayPlaceOrder(false));
            dispatch(handleModalData({ data: {} }));
            arrOrderCartData = [...arrScripsData];
        }
        //BT-106965 : OrderCart - SideTray : ManasaB : 29-07-2024 : Security measure issue - End
        const bObjSelectedCartRowData = Object?.keys(objSelectedCartRowData)?.length > 0 && objSelectedCartRowData?.orders.length > 0; //BT-106965 : Ordercart : SAT1 Issues : ManasaB : 08-04-2024 
        var arrOrderData = [];
        if (arrOrderCartData?.length != 0) {
            arrOrderCartData?.forEach((ele, i) => {
                let objData = {
                    id: i + 1,
                    buySellType: ele["BUY/SELL"],
                    productType: ele["PROD TYPE"].toUpperCase(),
                    orderType: ele["ORDER TYPE"],
                    validity: ele["VALIDITY"],
                    exchange: ele["SYMBOL"][WATCHLIST_GRID_INDEX.EXCHANGE],
                    count: ele["QTY"],
                    amo: ele["AMO"],
                    slTrigger: ele["SL TRIGGER"],
                    slLimit: ele["SL LIMIT"],
                    price: ele["PRICE"],
                    exchangeId: ele["SYMBOL"][WATCHLIST_GRID_INDEX.SEGMENT_ID],
                    token: ele["SYMBOL"][WATCHLIST_GRID_INDEX.TOKEN],
                    decimalLocator: ele["SYMBOL"][WATCHLIST_GRID_INDEX.DECIMAL_LOCATOR],
                    decimalLocatorLength: ele["SYMBOL"][WATCHLIST_GRID_INDEX.DECIMAL_LOCATOR_LENGTH],
                    symbol: ele["SYMBOL"][WATCHLIST_GRID_INDEX.SYMBOL],
                    series: ele["SYMBOL"][WATCHLIST_GRID_INDEX.SERIES],
                    instrument: ele["SYMBOL"][WATCHLIST_GRID_INDEX.INSTRUMENT],
                    exchangeSegment: ele["SYMBOL"][WATCHLIST_GRID_INDEX.EXCHANGE_SEGMENT],
                    isinCode: ele["SYMBOL"][WATCHLIST_GRID_INDEX.ISIN_CODE],
                    securityDesc: ele["SYMBOL"][WATCHLIST_GRID_INDEX.SECURITY_DESCRIPTION],
                    priceTick: ele["SYMBOL"][WATCHLIST_GRID_INDEX.PRICE_TICK] * ele["SYMBOL"][WATCHLIST_GRID_INDEX.DECIMAL_LOCATOR],//BT-106965 : Ordercart : SAT2 Issues : ManasaB : 11-06-2024 
                    mappedSegId: ele["SYMBOL"][WATCHLIST_GRID_INDEX.MAPPED_SEGMENT_ID],
                    marketLot: ele["SYMBOL"][WATCHLIST_GRID_INDEX.REGULAR_LOT]// BT-106965 : OrderCart: SAT2 : ManasaB : 17-05-2024
                };
                arrOrderData.push(objData);
            });
            //BT-106965 : OrderCart - SideTray : ManasaB : 29-07-2024 : Security measure issue - Start
            if (layoutType == LAYOUT_TYPE.HORIZONTAL) {
                dispatch(storeGridData(arrOrderCartData));
                dispatch(handleModal([{ 'ORDER_CART_NAME_MODAL': true }, { 'ORDER_ENTRY_MODAL': false }]));
                dispatch(handleModalData({
                    data: {
                        orderCartInfo: arrOrderData, orderCartPayloadInfo: orderCartPayloadInfo,
                        orderEntryTab: 'multi_scrip', activeTabKey: 'basket',
                        method: strIdentifyOrderCartMethod,
                        ordercartName: bObjSelectedCartRowData ? (objSelectedCartRowData?.ordercartName) : strCartName,
                        strOrderCartId: bObjSelectedCartRowData ? (objSelectedCartRowData?.ordercartId) : strCartId, isGoback: (objModalData?.data?.isGoBack) ? objModalData?.data?.isGoBack : isGoBackConfirm //BT-106965 : Ordercart : SAT1 Issues : ManasaB : 16-04-2024  
                    }
                }));
                setStrCartName('');
            }
            else {
                dispatch(getOrderDataBackupVertical([...arrScripsData]));
                setBIsShowCreateCart(true);
                dispatch(getOrderCartScrps(arrOrderData));
            }
            //BT-106965 : OrderCart - SideTray : ManasaB : 29-07-2024 : Security measure issue - End
        }
        // else {
        //     dispatch(toastConfig({ autoDismiss: true, show: true, message: `Cart is Empty` }));
        // }
        //BT-106965 : Ordercart : SAT1 Issues : ManasaB : 02-04-2024 : To restrict scrips if exceeds count - End

    };
    const handleOpenOrderNameModal = useCallback(() => {
        //BT-106965 : Order Cart : Side Tray : ManasaB : 23-07-2024 - Start
        let arrOrderCartData = [];
        let bObjSelectedCartRowData = false;
        if (layoutType == LAYOUT_TYPE.HORIZONTAL) {
            MULTISCRIP_ORDER_CART_GRID_REF?.current?.api?.forEachNode((rowNode, index) => {
                arrOrderCartData.push(rowNode?.data);
            });
            bObjSelectedCartRowData = Object?.keys(objSelectedCartRowData)?.length > 0 && objSelectedCartRowData?.orders.length > 0; //BT-106965 : Ordercart : SAT1 Issues : ManasaB : 08-04-2024 
        }
        else {
            arrOrderCartData = [...arrScripsData];
        }
        //BT-106965 : Ordercart : SAT1 Issues : ManasaB : 02-04-2024 : To restrict scrips if exceeds count - Start
        let arrSurvMeasuresData = [];
        if (arrOrderCartData?.length <= nOrderCartCount) {
            //BT-106965 : Ordercart : SAT2 Issues : ManasaB : 10-05-2024 : To restrict scrip which price is not multiple of price tick - Start
            let bPriceValidation = false;
            let strPrice = '';
            arrOrderCartData?.forEach(eachData => {
                let scripPrice = '';
                let nScripPrice = '';
                let nTriggerPrice = '';

                if (eachData["ORDER TYPE"] === ORDER_ENTRY_TYPES.RL) {
                    if (eachData["PRICE"] > 0)
                        scripPrice = eachData["PRICE"];
                }
                else if (eachData["ORDER TYPE"] === ORDER_ENTRY_TYPES.SL_MKT) {
                    if (eachData["SL TRIGGER"] > 0)
                        nTriggerPrice = eachData["SL TRIGGER"];
                }
                else if (eachData["ORDER TYPE"] === ORDER_ENTRY_TYPES.SL) {
                    if (eachData["SL LIMIT"] > 0) {
                        scripPrice = eachData["SL LIMIT"];
                    }
                    if (eachData["SL TRIGGER"] > 0) {
                        nTriggerPrice = eachData["SL TRIGGER"];
                    }
                }
                let DecimalLocator = eachData["SYMBOL"][WATCHLIST_GRID_INDEX.DECIMAL_LOCATOR];
                const nSelPriceTick = eachData["SYMBOL"][WATCHLIST_GRID_INDEX.PRICE_TICK] * eachData["SYMBOL"][WATCHLIST_GRID_INDEX.DECIMAL_LOCATOR];
                if (scripPrice > 0) {
                    nScripPrice = scripPrice;
                    strPrice = 'price';
                    const PriceinPaise = parseInt(Math.round(parseFloat((nScripPrice * DecimalLocator).toString())).toString());
                    const PriceTickInRs = (parseFloat(nSelPriceTick) / DecimalLocator).toFixed(eachData["SYMBOL"][WATCHLIST_GRID_INDEX.DECIMAL_LOCATOR_LENGTH]);
                    if (PriceinPaise % parseInt(nSelPriceTick) != 0) {
                        bPriceValidation = true;
                        dispatch(toastConfig({ autoDismiss: true, show: true, message: `The entered ${strPrice} value is not in multiple of price tick which is ${PriceTickInRs} ` }));
                        return false;
                    }
                }
                if (nTriggerPrice > 0) {
                    nScripPrice = nTriggerPrice;
                    strPrice = 'trigger price';
                    const PriceinPaise = parseInt(Math.round(parseFloat((nScripPrice * DecimalLocator).toString())).toString());
                    const PriceTickInRs = (parseFloat(nSelPriceTick) / DecimalLocator).toFixed(eachData["SYMBOL"][WATCHLIST_GRID_INDEX.DECIMAL_LOCATOR_LENGTH]);
                    if (PriceinPaise % parseInt(nSelPriceTick) != 0) {
                        bPriceValidation = true;
                        dispatch(toastConfig({ autoDismiss: true, show: true, message: `The entered ${strPrice} value is not in multiple of price tick which is ${PriceTickInRs}` }));
                        return false;
                    }
                }
            });
            if (bPriceValidation) {
                //  dispatch(toastConfig({ autoDismiss: true, show: true, message: `The entered ${strPrice} value is not in multiple of price tick which is  `}));
                dispatch(setShowSideTrayPlaceOrder(true));
                return false;
            }
            //BT-106965 : Ordercart : SAT2 Issues : ManasaB : 10-05-2024 : To restrict scrip which price is not multiple of price tick - End
            else {
                let bIsValidationFailed = false;
                arrOrderCartData.forEach(eachHoldingScrip => {
                    if (eachHoldingScrip["PROD TYPE"].toUpperCase().includes(ORDER_PRODUCT_TYPES.DELIVERY) && eachHoldingScrip["BUY/SELL"] == "SELL") {
                        const objHoldingScrip = holdingsScrips.find(eachScrip => eachScrip.nToken == eachHoldingScrip["SYMBOL"][WATCHLIST_GRID_INDEX.TOKEN]);
                        if (objHoldingScrip && Object.keys(objHoldingScrip).length > 0) {
                            if (eachHoldingScrip["QTY"] > parseInt(objHoldingScrip.TOTALFREEQUANTITY)) {
                                bIsValidationFailed = true;
                                dispatch(toastConfig({ autoDismiss: true, show: true, message: `Entered Qty is greater than Qty available in holdings for ${eachHoldingScrip["SYMBOL"][WATCHLIST_GRID_INDEX.SYMBOL]}.Short selling is not allowed for Delivery ` }));
                            }
                        }
                        else {
                            bIsValidationFailed = true;
                            dispatch(toastConfig({ autoDismiss: true, show: true, message: `Entered Qty is greater than Qty available in holdings for ${eachHoldingScrip["SYMBOL"][WATCHLIST_GRID_INDEX.SYMBOL]}.Short selling is not allowed for Delivery ` }));
                        }
                    }
                    //BT-106965 : Ordercart : Security Measures Warning : ManasaB : 24-04-2024 - Start
                    if (checkGSM == FACILITY_STR.ON && eachHoldingScrip["SYMBOL"][WATCHLIST_GRID_INDEX.SURV_MEASURE_DESCRIPTION] != null) {
                        let objSurvMeasure = {
                            marketSegmentId: getApiExchangeNameFromMktSegId(eachHoldingScrip["SYMBOL"][WATCHLIST_GRID_INDEX.SEGMENT_ID]),
                            token: eachHoldingScrip["SYMBOL"][WATCHLIST_GRID_INDEX.TOKEN],
                            cautionaryText: eachHoldingScrip["SYMBOL"][WATCHLIST_GRID_INDEX.SURV_MEASURE_DESCRIPTION],
                            textString: `${eachHoldingScrip["SYMBOL"][WATCHLIST_GRID_INDEX.EXCHANGE]} ${eachHoldingScrip["SYMBOL"][WATCHLIST_GRID_INDEX.SYMBOL]} ${eachHoldingScrip["SYMBOL"][WATCHLIST_GRID_INDEX.SERIES]} <br>  Graded Surveillance Measure <br> ${eachHoldingScrip["SYMBOL"][WATCHLIST_GRID_INDEX.SURV_MEASURE_DESCRIPTION]}`
                        };
                        arrSurvMeasuresData.push(`${eachHoldingScrip["SYMBOL"][WATCHLIST_GRID_INDEX.EXCHANGE]} ${eachHoldingScrip["SYMBOL"][WATCHLIST_GRID_INDEX.SYMBOL]} ${eachHoldingScrip["SYMBOL"][WATCHLIST_GRID_INDEX.SERIES]} Graded Surveillance Measure ${eachHoldingScrip["SYMBOL"][WATCHLIST_GRID_INDEX.SURV_MEASURE_DESCRIPTION]}`);
                        let check = arrSurvMeasureData.some(eachWord => eachWord?.textString?.includes(`${eachHoldingScrip["SYMBOL"][WATCHLIST_GRID_INDEX.EXCHANGE]} ${eachHoldingScrip["SYMBOL"][WATCHLIST_GRID_INDEX.SYMBOL]} ${eachHoldingScrip["SYMBOL"][WATCHLIST_GRID_INDEX.SERIES]}`));
                        // if (!arrSurvMeasureData.some(eachWord.includes(`${eachHoldingScrip["SYMBOL"][WATCHLIST_GRID_INDEX.EXCHANGE]} ${eachHoldingScrip["SYMBOL"][WATCHLIST_GRID_INDEX.SYMBOL]} ${eachHoldingScrip["SYMBOL"][WATCHLIST_GRID_INDEX.SERIES]}`))) { 
                        if (!check) {
                            setArrSurvMeasureData(curr => [...curr, objSurvMeasure]);
                        }
                    }
                });
                //BT-106965 : Ordercart : Security Measures Warning : ManasaB : 24-04-2024 - End
                if (bIsValidationFailed) {
                    dispatch(setShowSideTrayPlaceOrder(true));
                }
                else if (arrSurvMeasuresData?.length > 0 || isSurvMeasure) {
                    setIsSurvMeasure(true);
                    dispatch(setShowSideTrayPlaceOrder(true));
                }
                else {
                    var arrOrderData = [];
                    if (arrOrderCartData?.length != 0) {
                        arrOrderCartData?.forEach((ele, i) => {
                            let objData = {
                                id: i + 1,
                                buySellType: ele["BUY/SELL"],
                                productType: ele["PROD TYPE"].toUpperCase(),
                                orderType: ele["ORDER TYPE"],
                                validity: ele["VALIDITY"],
                                exchange: ele["SYMBOL"][WATCHLIST_GRID_INDEX.EXCHANGE],
                                count: ele["QTY"],
                                amo: ele["AMO"],
                                slTrigger: ele["SL TRIGGER"],
                                slLimit: ele["SL LIMIT"],
                                price: ele["PRICE"],
                                exchangeId: ele["SYMBOL"][WATCHLIST_GRID_INDEX.SEGMENT_ID],
                                token: ele["SYMBOL"][WATCHLIST_GRID_INDEX.TOKEN],
                                decimalLocator: ele["SYMBOL"][WATCHLIST_GRID_INDEX.DECIMAL_LOCATOR],
                                decimalLocatorLength: ele["SYMBOL"][WATCHLIST_GRID_INDEX.DECIMAL_LOCATOR_LENGTH],
                                symbol: ele["SYMBOL"][WATCHLIST_GRID_INDEX.SYMBOL],
                                series: ele["SYMBOL"][WATCHLIST_GRID_INDEX.SERIES],
                                instrument: ele["SYMBOL"][WATCHLIST_GRID_INDEX.INSTRUMENT],
                                exchangeSegment: ele["SYMBOL"][WATCHLIST_GRID_INDEX.EXCHANGE_SEGMENT],
                                isinCode: ele["SYMBOL"][WATCHLIST_GRID_INDEX.ISIN_CODE],
                                securityDesc: ele["SYMBOL"][WATCHLIST_GRID_INDEX.SECURITY_DESCRIPTION],
                                priceTick: ele["SYMBOL"][WATCHLIST_GRID_INDEX.PRICE_TICK] * ele["SYMBOL"][WATCHLIST_GRID_INDEX.DECIMAL_LOCATOR],//BT-106965 : Ordercart : SAT2 Issues : ManasaB : 11-06-2024
                                mappedSegId: ele["SYMBOL"][WATCHLIST_GRID_INDEX.MAPPED_SEGMENT_ID],
                                marketLot: ele["SYMBOL"][WATCHLIST_GRID_INDEX.REGULAR_LOT]// BT-106965 : OrderCart: SAT2 : ManasaB : 17-05-2024 
                            };
                            arrOrderData.push(objData);
                        });
                        if (layoutType == LAYOUT_TYPE.HORIZONTAL) {
                            dispatch(storeGridData(arrOrderCartData));
                            dispatch(handleModal([{ 'ORDER_ENTRY_MODAL': false }, { 'ORDER_CART_NAME_MODAL': true }]), true);
                            dispatch(handleModalData({
                                data: {
                                    orderCartInfo: arrOrderData, orderCartPayloadInfo: orderCartPayloadInfo,
                                    orderEntryTab: 'multi_scrip', activeTabKey: 'basket',
                                    method: strIdentifyOrderCartMethod,
                                    ordercartName: bObjSelectedCartRowData ? (objSelectedCartRowData?.ordercartName) : strCartName,
                                    strOrderCartId: bObjSelectedCartRowData ? (objSelectedCartRowData?.ordercartId) : strCartId, isGoback: (objModalData?.data?.isGoback) ? objModalData?.data?.isGoback : false //BT-106965 : Ordercart : SAT1 Issues : ManasaB : 16-04-2024  
                                }
                            }));
                            setStrCartName('');
                        }
                        else {
                            dispatch(getOrderDataBackupVertical([...arrScripsData]));
                            setBIsShowCreateCart(true);
                            dispatch(getOrderCartScrps(arrOrderData));
                        }
                        //BT-106965 : Order Cart : Side Tray : ManasaB : 23-07-2024 - End
                    }
                    else {
                        if (layoutType === LAYOUT_TYPE.VERTICAL) {
                            dispatch(setShowSideTrayPlaceOrder(true));
                        }
                        dispatch(toastConfig({ autoDismiss: true, show: true, message: `Cart is Empty` }));
                    }
                    //BT-106965 : Ordercart : SAT1 Issues : ManasaB : 02-04-2024 : To restrict scrips if exceeds count - End
                }
            }
        }
        else {
            dispatch(setShowSideTrayPlaceOrder(true));
            dispatch((toastConfig({ autoDismiss: true, show: true, message: `You can not add more than ${nOrderCartCount} in single cart` })));
        }

    }, [objSelectedCartRowData, orderCartInfo, orderCartPayloadInfo, strIdentifyOrderCartMethod, strCartName, arrSurvMeasureData, isSurvMeasure, arrScripsData]);
    //BT-106965 : Ordercart : SAT1 Issues : ManasaB : 18-04-2024 Security Measure - End
    //BT-106965 : Order Cart : Side Tray : ManasaB : 23-07-2024 - Start
    useImperativeHandle(ref, () => ({
        handleOpenOrderNameModal,
        saveCartData,
        handleMarginInfo
    }));
    useEffect(() => {
        if (bIsConfirmBack || bIsSaveCartBack) {
            setArrMarketPrice([...arrOrderCartMarketPriceData]);
            setArrScripsData(arrOrderBackupData);
        }
    }, [bIsConfirmBack, bIsSaveCartBack]);
    //BT-106965 : Order Cart : Side Tray : ManasaB : 23-07-2024 - End
    const getRowId = useCallback((params) => {
        if (params?.data) {
            return params?.data?.id;
        } else {
        }
    }, []);
    useEffect(() => {
        if (location.pathname === "/ordercart") {
            inputRef.current.focus();
        }
    }, []);

    //Ammersha changes -Start
    function divideArrayIntoGroups(array, groupSize) {
        let dividedArrays = [];
        let currentIndex = 0;

        while (currentIndex < array?.length) {
            let curentGroup = array?.slice(currentIndex, currentIndex + groupSize);
            dividedArrays?.push(curentGroup);
            currentIndex += groupSize;
        }
        return dividedArrays;
    }

    //Ameersha changes - ENd
    useEffect(() => {
        //BT-106965 : Ordercart : SAT2 Issues : ManasaB : 03-06-2024 : Start
        //BREEZE-305 : ManasaB : 16-10-2024 : Watchlist Side tray- Order Cart Order entry - Start
        if (layoutType === LAYOUT_TYPE.HORIZONTAL) {
            if (rowData?.length > 0) {
                const arrOrderInfo = [...rowData];
                if (arrOrderInfo.length > 0) {
                    calculatedAndGetOrderMarginInfoFor(arrOrderInfo);
                }
            }
            //BT-106965 : Ordercart : SAT2 Issues : ManasaB : 03-06-2024 : End
        }
        //BREEZE-305 : ManasaB : 16-10-2024 : Watchlist Side tray- Order Cart Order entry - End
    }, [rowData]);
    //BT-106965 : Order Cart : Side Tray : ManasaB : 23-07-2024 - Start
    const handleAddScrips = (e) => {
        setBIsShowSearchScrip(true);
    };
    const handleEdit = (event, data) => {
        event.preventDefault();
        setBIsShowScripDetails(true);
        setObjSelectedScrip(data);
        dispatch(getExchangeWiseScripInfo(data?.SYMBOL));
        return () => {
            const arrDistinctScripExchangesSubscription = arrDistinctScripExchanges?.map(scrip => ({ exchangeId: scrip[WATCHLIST_GRID_INDEX.SEGMENT_ID], token: scrip[WATCHLIST_GRID_INDEX.TOKEN], isSubscribe: false }));
            sendTouchlineRequest(arrDistinctScripExchangesSubscription);
        };

    };
    const handleHideScripDetails = (event, data) => {
        setBIsShowScripDetails(false);
        setObjSelectedScrip({});

    };
    const handleDropdown = (e, id) => {
        if (e.target.name === 'productType') {
            setArrScripsData(prevItem => prevItem.map(each => each.id == id ? { ...each, "PROD TYPE": e.target.value } : each));
        }
        else if (e.target.name === 'orderType') {
            //BREEZE-305 :Watchlist Side tray- Order Cart Order entry :ManasaB : 20-11-2024 : SAT issues - Start
            if (e.target.value === ORDER_ENTRY_TYPES.SL || e.target.value === ORDER_ENTRY_TYPES.SL_MKT) {
                setToggleStopLoss(true);
            }
            else {
                setToggleStopLoss(false);
            }
            setArrScripsData(prevItem => prevItem.map(each => each.id == id ? { ...each, "ORDER TYPE": e.target.value } : each));
            let objScripInfo = arrScripsData.find(eachData => eachData.id == id);
            if (e.target.value === ORDER_ENTRY_TYPES.SL_MKT) {
                let objMarketPrice = arrMarketPrice.find(eachData => eachData.id == id);
                setArrScripsData(prevItem => prevItem.map(each => each.id == id ? { ...each, PRICE: objMarketPrice?.price } : each));
                setObjRangeColor(prevData => ({ ...prevData, price: 'color-text' }));
                if (Number(objScripInfo['SL TRIGGER']) === 0) {
                    setBIsPlaceOrderBtnDisabled(true);
                    setObjRangeColor(prevData => ({ ...prevData, trigger: 'color-error' }));
                }
            }
            else if (e.target.value === ORDER_ENTRY_TYPES.SL) {
                let objMarketPrice = arrMarketPrice.find(eachData => eachData.id == id);
                setArrScripsData(prevItem => prevItem.map(each => each.id == id ? { ...each, PRICE: objMarketPrice?.price } : each));
                setObjRangeColor(prevData => ({ ...prevData, price: 'color-text' }));
                if (Number(objScripInfo["SL LIMIT"]) == 0 && Number(objScripInfo['SL TRIGGER']) == 0) {
                    setBIsPlaceOrderBtnDisabled(true);
                    setObjRangeColor(prevData => ({ ...prevData, limit: 'color-error', trigger: 'color-error' }));
                }
                else if (Number(objScripInfo['SL TRIGGER']) == 0 && Number(objScripInfo["SL LIMIT"]) != 0) {
                    setBIsPlaceOrderBtnDisabled(true);
                    setObjRangeColor(prevData => ({ ...prevData, trigger: 'color-error' }));
                }
                else if (Number(objScripInfo['SL TRIGGER']) != 0 && Number(objScripInfo["SL LIMIT"]) == 0) {
                    setBIsPlaceOrderBtnDisabled(true);
                    setObjRangeColor(prevData => ({ ...prevData, limit: 'color-error' }));
                }
                else {
                    setBIsPlaceOrderBtnDisabled(false);
                    setObjRangeColor(prevData => ({ ...prevData, limit: 'color-text', trigger: 'color-text' }));
                }
            }
            else {
                setBIsPlaceOrderBtnDisabled(false);
                if (e.target.value === ORDER_ENTRY_TYPES.RL) {
                    let nRange = objScripInfo["Range"];
                    let minRange = nRange.split('-')[0];
                    let maxRange = nRange.split('-')[1];
                    if ((parseFloat(Number(objScripInfo["PRICE"])) < parseFloat(Number(minRange))) || (parseFloat(Number(objScripInfo["PRICE"])) > parseFloat(Number(maxRange)))) {
                        setObjRangeColor(prevData => ({ ...prevData, price: 'color-error' }));
                    }
                    else {
                        setObjRangeColor(prevData => ({ ...prevData, price: 'color-text' }));
                    }
                }
                else if (e.target.value === ORDER_ENTRY_TYPES.RL_MKT) {
                    let objMarketPrice = arrMarketPrice.find(eachData => eachData.id == id);
                    setArrScripsData(prevItem => prevItem.map(each => each.id == id ? { ...each, PRICE: objMarketPrice?.price } : each));
                    setObjRangeColor(prevData => ({ ...prevData, price: 'color-text' }));
                }
                else {
                    setObjRangeColor(prevData => ({ ...prevData, price: 'color-text' }));
                }
            }
            //BREEZE-305 :Watchlist Side tray- Order Cart Order entry :ManasaB : 20-11-2024 : SAT issues - End
        }
        else if (e.target.name === 'validity') {
            setArrScripsData(prevItem => prevItem.map(each => each.id == id ? { ...each, "VALIDITY": e.target.value } : each));
        }

    };
    useEffect(() => {
        if (layoutType == LAYOUT_TYPE.VERTICAL && arrScripsData?.length > 0) {
            let arrScripsInfo = [...arrScripsData];
            for (let i = 0; i < arrScripsInfo?.length; i++) {
                let arrRange = arrScripsInfo[i]["Range"] != '0.00-0.00' ? arrScripsInfo[i]["Range"]?.split("-") : [];
                let minRange = arrRange?.length > 0 ? parseFloat(arrRange[0]) : 0;
                let maxRange = arrRange?.length > 0 ? parseFloat(arrRange[1]) : 0;
                if (arrScripsInfo[i]["ORDER TYPE"] === ORDER_ENTRY_TYPES.SL_MKT) {
                    if (Number(arrScripsInfo[i]["SL TRIGGER"]) == 0) {
                        setBIsPlaceOrderBtnDisabled(true);
                        setObjRangeColor(prevData => ({ ...prevData, trigger: 'color-error' }));
                    }
                    else {
                        setBIsPlaceOrderBtnDisabled(false);
                        if ((parseFloat(Number(arrScripsInfo[i]["SL TRIGGER"])) < parseFloat(Number(minRange))) || (parseFloat(Number(arrScripsInfo[i]["SL TRIGGER"])) > parseFloat(Number(maxRange)))) {
                            setObjRangeColor(prevData => ({ ...prevData, trigger: 'color-error' }));
                        }
                        else {
                            setObjRangeColor(prevData => ({ ...prevData, trigger: 'color-text' }));
                        }
                    }
                }
                else if (arrScripsInfo[i]["ORDER TYPE"] === ORDER_ENTRY_TYPES.SL) {

                    if (Number(arrScripsInfo[i]["SL LIMIT"]) == 0 && Number(arrScripsInfo[i]['SL TRIGGER']) == 0) {
                        setBIsPlaceOrderBtnDisabled(true);
                        setObjRangeColor(prevData => ({ ...prevData, limit: 'color-error', trigger: 'color-error' }));
                    }
                    else if (Number(arrScripsInfo[i]['SL TRIGGER']) == 0 && Number(arrScripsInfo[i]["SL LIMIT"]) != 0) {
                        setBIsPlaceOrderBtnDisabled(true);
                        setObjRangeColor(prevData => ({ ...prevData, trigger: 'color-error' }));
                    }
                    else if (Number(arrScripsInfo[i]['SL TRIGGER']) != 0 && Number(arrScripsInfo[i]["SL LIMIT"]) == 0) {
                        setBIsPlaceOrderBtnDisabled(true);
                        setObjRangeColor(prevData => ({ ...prevData, limit: 'color-error' }));
                    }
                    else {
                        setBIsPlaceOrderBtnDisabled(false);
                        if ((parseFloat(Number(arrScripsInfo[i]["SL LIMIT"])) < parseFloat(Number(minRange))) || (parseFloat(Number(arrScripsInfo[i]["SL LIMIT"])) > parseFloat(Number(maxRange)))) {
                            setObjRangeColor(prevData => ({ ...prevData, limit: 'color-error' }));
                        }
                        else {
                            setObjRangeColor(prevData => ({ ...prevData, limit: 'color-text' }));
                        }
                        if ((parseFloat(Number(arrScripsInfo[i]["SL TRIGGER"])) < parseFloat(Number(minRange))) || (parseFloat(Number(arrScripsInfo[i]["SL TRIGGER"])) > parseFloat(Number(maxRange)))) {
                            setObjRangeColor(prevData => ({ ...prevData, trigger: 'color-error' }));
                        }
                        else {
                            setObjRangeColor(prevData => ({ ...prevData, trigger: 'color-text' }));
                        }
                    }
                }
                else if (arrScripsInfo[i]["ORDER TYPE"] === ORDER_ENTRY_TYPES.RL) {
                    if (Number(arrScripsInfo[i]["PRICE"]) == 0) {
                        setBIsPlaceOrderBtnDisabled(true);
                        setObjRangeColor(prevData => ({ ...prevData, price: 'color-error' }));
                    }
                    else {

                        setBIsPlaceOrderBtnDisabled(false);
                        if ((parseFloat(Number(arrScripsInfo[i]["PRICE"])) < parseFloat(Number(minRange))) || (parseFloat(Number(arrScripsInfo[i]["PRICE"])) > parseFloat(Number(maxRange)))) {
                            setObjRangeColor(prevData => ({ ...prevData, price: 'color-error' }));
                        }
                        else {
                            setObjRangeColor(prevData => ({ ...prevData, price: 'color-text' }));
                        }
                    }
                }
                else {
                    setBIsPlaceOrderBtnDisabled(false);
                }
            }
        }
    }, [arrScripsData, activeTabKey, multiScripOrderActiveTabKey]);
    //Quantity
    const handleQuantity = (e, id) => {
        if (parseInt(e.target.value) <= 0) {
            setBIsPlaceOrderBtnDisabled(true);
        } else if (!e?.target?.value?.includes('.') && e.target.value < 99999999)
            setArrScripsData(prevItem => prevItem.map(each => each.id == id ? { ...each, QTY: e.target.value } : each));
        setBIsPlaceOrderBtnDisabled(false);
    };
    const handleQuantityIncDec = (name, id) => {
        let objScripInfo = arrScripsData.find(each => each.id == id);
        let nIncrementValue = parseInt(objScripInfo["SYMBOL"][WATCHLIST_GRID_INDEX.REGULAR_LOT]);
        switch (name) {
            case "subQuantity":
                if (objScripInfo["QTY"] > nIncrementValue) {
                    setArrScripsData(prevItem => prevItem.map(each => each.id == id ? { ...each, QTY: each["QTY"] - nIncrementValue } : each));
                    setBIsPlaceOrderBtnDisabled(false);
                } else { };
                break;
            case "addQuantity":
                if (objScripInfo["QTY"] < 99999999) {
                    setArrScripsData(prevItem => prevItem.map(each => each.id == id ? { ...each, QTY: each["QTY"] + nIncrementValue } : each));
                    break;
                }
            default:
        }
    };

    //Price
    const handlePrice = (e, id) => {
        let objScripInfo = arrScripsData.find(each => each.id == id);
        let { value } = e.target;
        value = value?.replace(/[^0-9.]/g, '');
        let decimalCount = value?.split('.').length - 1;
        if (decimalCount > 1) {
            value = value.slice(0, value.lastIndexOf('.'));
        }
        let valueParts = value.split('.');
        if (valueParts[1] && valueParts[1].length > objScripInfo["SYMBOL"][WATCHLIST_GRID_INDEX.DECIMAL_LOCATOR_LENGTH]) {
            value = `${valueParts[0]}.${valueParts[1].slice(0, 2)}`;
        }
        setArrScripsData(prevItem => prevItem.map(each => each.id == id ? { ...each, PRICE: value } : each));
        setBIsPlaceOrderBtnDisabled(false);
    };
    const handlePriceIncDec = (name, id) => {
        let objScripInfo = arrScripsData.find(each => each.id == id);
        let nIncrementValue = objScripInfo["SYMBOL"][WATCHLIST_GRID_INDEX.PRICE_TICK];
        switch (name) {
            case "subPrice":
                if (objScripInfo["PRICE"] > 0) {
                    let updatedValue = (parseFloat(objScripInfo["PRICE"]) - nIncrementValue).toFixed(objScripInfo["SYMBOL"][WATCHLIST_GRID_INDEX.DECIMAL_LOCATOR_LENGTH]);
                    setArrScripsData(prevItem => prevItem.map(each => each.id == id ? { ...each, PRICE: updatedValue } : each));
                    setBIsPlaceOrderBtnDisabled(false);
                } else { };
                break;
            case "addPrice":
                if (objScripInfo["PRICE"].length <= 0) {
                    let updatedValue = objScripInfo["SYMBOL"][WATCHLIST_GRID_INDEX.PRICE_TICK].toFixed(props.data["SYMBOL"][WATCHLIST_GRID_INDEX.DECIMAL_LOCATOR_LENGTH]);
                    setArrScripsData(prevItem => prevItem.map(each => each.id == id ? { ...each, PRICE: updatedValue } : each));
                }
                else {
                    let updatedValue = (parseFloat(objScripInfo["PRICE"]) + nIncrementValue).toFixed(objScripInfo["SYMBOL"][WATCHLIST_GRID_INDEX.DECIMAL_LOCATOR_LENGTH]);
                    setArrScripsData(prevItem => prevItem.map(each => each.id == id ? { ...each, PRICE: updatedValue } : each));
                    break;
                }
            default:
        }
    };

    const handlePriceBlur = useCallback((e, id) => {
        e.preventDefault();
        setArrScripsData(prevArray => {
            let objScripInfo = prevArray.find(each => each.id == id);
            let arrRange = objScripInfo["Range"] != '0.00-0.00' ? objScripInfo["Range"]?.split("-") : [];
            let minRange = arrRange?.length > 0 ? parseFloat(arrRange[0]) : 0;
            let maxRange = arrRange?.length > 0 ? parseFloat(arrRange[1]) : 0;
            if (objScripInfo["PRICE"] == '') {
                setBIsPlaceOrderBtnDisabled(true);
                setObjRangeColor(prevData => ({ ...prevData, price: 'color-text' }));
            }
            else {
                if (!objScripInfo["PRICE"]?.toString()?.includes('.')) {
                    objScripInfo["PRICE"] = parseFloat(objScripInfo["PRICE"]).toFixed(objScripInfo["SYMBOL"][WATCHLIST_GRID_INDEX.DECIMAL_LOCATOR_LENGTH]);
                }

                if (parseFloat(objScripInfo["PRICE"]) <= 0) {
                    setBIsPlaceOrderBtnDisabled(true);
                    setObjRangeColor(prevData => ({ ...prevData, price: 'color-error' }));
                }
                else {
                    if (parseFloat(objScripInfo["PRICE"]) > maxRange || parseFloat(objScripInfo["PRICE"]) < minRange) {
                        setBIsPlaceOrderBtnDisabled(true);
                        setObjRangeColor(prevData => ({ ...prevData, price: 'color-error' }));
                    }
                    else {
                        setBIsPlaceOrderBtnDisabled(false);
                        setObjRangeColor(prevData => ({ ...prevData, price: 'color-text' }));
                    }
                }
            }
            const newArray = prevArray.map(each => each.id === id ? { ...each, objScripInfo } : each);
            return newArray;
        });
    }, []);
    //SLTRIGGER
    const handleSLTrigger = (e, id) => {
        let objScripInfo = arrScripsData.find(each => each.id == id);
        let { value } = e.target;
        value = value?.replace(/[^0-9.]/g, '');
        let decimalCount = value?.split('.').length - 1;
        if (decimalCount > 1) {
            value = value.slice(0, value.lastIndexOf('.'));
        }
        let valueParts = value.split('.');
        if (valueParts[1] && valueParts[1].length > objScripInfo["SYMBOL"][WATCHLIST_GRID_INDEX.DECIMAL_LOCATOR_LENGTH]) {
            value = `${valueParts[0]}.${valueParts[1].slice(0, 2)}`;
        }
        setArrScripsData(prevItem => prevItem.map(each => each.id === id ? { ...each, "SL TRIGGER": value } : each));
        setBIsPlaceOrderBtnDisabled(false);
    };
    const handleSLTriggerIncDec = (name, id) => {
        let objScripInfo = arrScripsData.find(each => each.id == id);
        let nIncrementValue = objScripInfo["SYMBOL"][WATCHLIST_GRID_INDEX.PRICE_TICK];
        switch (name) {
            case "subSLTrigger":
                if (objScripInfo["SL TRIGGER"] > 0) {
                    let updatedValue = (parseFloat(objScripInfo["SL TRIGGER"]) - nIncrementValue).toFixed(objScripInfo["SYMBOL"][WATCHLIST_GRID_INDEX.DECIMAL_LOCATOR_LENGTH]);
                    setArrScripsData(prevItem => prevItem.map(each => each.id == id ? { ...each, "SL TRIGGER": updatedValue } : each));
                    setBIsPlaceOrderBtnDisabled(false);
                } else { };
                break;
            case "addSLTrigger":
                if (objScripInfo["SL TRIGGER"] <= 0) {
                    let updatedValue = objScripInfo["SYMBOL"][WATCHLIST_GRID_INDEX.PRICE_TICK].toFixed(objScripInfo["SYMBOL"][WATCHLIST_GRID_INDEX.DECIMAL_LOCATOR_LENGTH]);
                    setArrScripsData(prevItem => prevItem.map(each => each.id == id ? { ...each, "SL TRIGGER": updatedValue } : each));
                }
                else {
                    let updatedValue = (parseFloat(objScripInfo["SL TRIGGER"]) + nIncrementValue).toFixed(objScripInfo["SYMBOL"][WATCHLIST_GRID_INDEX.DECIMAL_LOCATOR_LENGTH]);
                    setArrScripsData(prevItem => prevItem.map(each => each.id == id ? { ...each, "SL TRIGGER": updatedValue } : each));
                    break;
                }
            default:
        }
    };
    const handleTriggerFocus = useCallback((id) => {
        let objScripInfo = arrScripsData.find(each => each.id == id);
        if (parseFloat(Number(objScripInfo["SL TRIGGER"])) == 0) {
            setArrScripsData(prevItem => prevItem.map(each => each.id == id ? { ...each, "SL TRIGGER": '' } : each));
        }
    }, [arrScripsData]);
    const handleTriggerBlur = useCallback((id) => {
        setArrScripsData(prevArray => {
            let objScripInfo = prevArray.find(each => each.id == id);
            let arrRange = objScripInfo["Range"] != '0.00-0.00' ? objScripInfo["Range"]?.split("-") : [];
            let minRange = arrRange?.length > 0 ? parseFloat(arrRange[0]) : 0;
            let maxRange = arrRange?.length > 0 ? parseFloat(arrRange[1]) : 0;
            if (objScripInfo["SL TRIGGER"] == '') {
                setBIsPlaceOrderBtnDisabled(true);
                setArrScripsData(prevItem => prevItem.map(each => each.id == id ? { ...each, "SL TRIGGER": '0.00' } : each));
                setObjRangeColor(prevData => ({ ...prevData, trigger: 'color-error' }));
            }
            else {
                if (!objScripInfo["SL TRIGGER"]?.toString()?.includes('.')) {
                    objScripInfo["SL TRIGGER"] = parseFloat(objScripInfo["SL TRIGGER"]).toFixed(objScripInfo["SYMBOL"][WATCHLIST_GRID_INDEX.DECIMAL_LOCATOR_LENGTH]);
                }

                if (parseFloat(Number(objScripInfo["SL TRIGGER"])) <= 0) {
                    setBIsPlaceOrderBtnDisabled(true);
                    setObjRangeColor(prevData => ({ ...prevData, trigger: 'color-error' }));
                }
                else {
                    if (parseFloat(Number(objScripInfo["SL TRIGGER"])) > maxRange || parseFloat(Number(objScripInfo["SL TRIGGER"])) < minRange) {
                        setBIsPlaceOrderBtnDisabled(true);
                        setObjRangeColor(prevData => ({ ...prevData, trigger: 'color-error' }));
                    }
                    else {
                        setObjRangeColor(prevData => ({ ...prevData, trigger: 'color-text' }));
                        if (objScripInfo["ORDER TYPE"] == 'SL') {
                            if (parseFloat(objScripInfo["SL LIMIT"]) == 0) {
                                setBIsPlaceOrderBtnDisabled(true);
                            }
                            else {
                                setBIsPlaceOrderBtnDisabled(false);
                                setObjRangeColor(prevData => ({ ...prevData, trigger: 'color-text' }));
                            }
                        }
                        else {
                            setBIsPlaceOrderBtnDisabled(false);
                            setObjRangeColor(prevData => ({ ...prevData, trigger: 'color-text' }));
                        }
                    }
                }
            }
            const newArray = prevArray.map(each => each.id === id ? { ...each, objScripInfo } : each);
            return newArray;
        });
    }, []);
    //SLLMIT
    const handleLimitFocus = useCallback((id) => {
        let objScripInfo = arrScripsData.find(each => each.id == id);
        if (parseFloat(Number(objScripInfo["SL LIMIT"])) == 0) {
            setArrScripsData(prevItem => prevItem.map(each => each.id == id ? { ...each, "SL LIMIT": '' } : each));
        }
    }, [arrScripsData]);
    const handleSLLimit = (e, id) => {
        let objScripInfo = arrScripsData.find(each => each.id == id);
        let { value } = e.target;
        value = value?.replace(/[^0-9.]/g, '');
        let decimalCount = value?.split('.').length - 1;
        if (decimalCount > 1) {
            value = value.slice(0, value.lastIndexOf('.'));
        }
        let valueParts = value.split('.');
        if (valueParts[1] && valueParts[1].length > objScripInfo["SYMBOL"][WATCHLIST_GRID_INDEX.DECIMAL_LOCATOR_LENGTH]) {
            value = `${valueParts[0]}.${valueParts[1].slice(0, 2)}`;
        }
        setArrScripsData(prevItem => prevItem.map(each => each.id == id ? { ...each, "SL LIMIT": value } : each));
        setBIsPlaceOrderBtnDisabled(false);
    };
    const handleSLLimitIncDec = (name, id) => {
        let objScripInfo = arrScripsData.find(each => each.id == id);
        let nIncrementValue = objScripInfo["SYMBOL"][WATCHLIST_GRID_INDEX.PRICE_TICK];
        switch (name) {
            case "subSLLimit":
                if (Number(objScripInfo["SL LIMIT"]) > 0) {
                    let updatedValue = (parseFloat(objScripInfo["SL LIMIT"]) - nIncrementValue).toFixed(objScripInfo["SYMBOL"][WATCHLIST_GRID_INDEX.DECIMAL_LOCATOR_LENGTH]);
                    setArrScripsData(prevItem => prevItem.map(each => each.id == id ? { ...each, "SL LIMIT": updatedValue } : each));
                    setBIsPlaceOrderBtnDisabled(false);
                } else { };
                break;
            case "addSLLimit":
                if (Number(objScripInfo["SL LIMIT"]) <= 0) {
                    let updatedValue = objScripInfo["SYMBOL"][WATCHLIST_GRID_INDEX.PRICE_TICK].toFixed(objScripInfo["SYMBOL"][WATCHLIST_GRID_INDEX.DECIMAL_LOCATOR_LENGTH]);
                    setArrScripsData(prevItem => prevItem.map(each => each.id == id ? { ...each, "SL LIMIT": updatedValue } : each));
                }
                else {
                    let updatedValue = (parseFloat(objScripInfo["SL LIMIT"]) + nIncrementValue).toFixed(objScripInfo["SYMBOL"][WATCHLIST_GRID_INDEX.DECIMAL_LOCATOR_LENGTH]);
                    setArrScripsData(prevItem => prevItem.map(each => each.id == id ? { ...each, "SL LIMIT": updatedValue } : each));
                    break;
                }
            default:
        }
    };

    const handleLimitBlur = useCallback((id) => {
        setArrScripsData(prevArray => {
            let objScripInfo = prevArray.find(each => each.id == id);
            let arrRange = objScripInfo["Range"] != '0.00-0.00' ? objScripInfo["Range"]?.split("-") : [];
            let minRange = arrRange?.length > 0 ? parseFloat(arrRange[0]) : 0;
            let maxRange = arrRange?.length > 0 ? parseFloat(arrRange[1]) : 0;
            if (objScripInfo["SL LIMIT"] == '') {
                setBIsPlaceOrderBtnDisabled(true);
                setObjRangeColor(prevData => ({ ...prevData, limit: 'color-error' }));
                setArrScripsData(prevItem => prevItem.map(each => each.id == id ? { ...each, "SL LIMIT": '0.00' } : each));
            }
            else {
                if (!objScripInfo["SL LIMIT"]?.toString()?.includes('.')) {
                    objScripInfo["SL LIMIT"] = parseFloat(objScripInfo["SL LIMIT"]).toFixed(objScripInfo["SYMBOL"][WATCHLIST_GRID_INDEX.DECIMAL_LOCATOR_LENGTH]);
                }

                if (parseFloat(objScripInfo["SL LIMIT"]) <= 0) {
                    setBIsPlaceOrderBtnDisabled(true);
                    setObjRangeColor(prevData => ({ ...prevData, limit: 'color-error' }));
                }
                else {
                    if (parseFloat(Number(objScripInfo["SL LIMIT"])) > maxRange || parseFloat(Number(objScripInfo["SL LIMIT"])) < minRange) {
                        setBIsPlaceOrderBtnDisabled(true);
                        setObjRangeColor(prevData => ({ ...prevData, limit: 'color-error' }));
                    }
                    else {
                        setObjRangeColor(prevData => ({ ...prevData, limit: 'color-text' }));
                        if (objScripInfo["ORDER TYPE"] == 'SL') {
                            if (parseFloat(objScripInfo["SL TRIGGER"]) == 0) {
                                setBIsPlaceOrderBtnDisabled(true);
                            }
                            else {
                                setBIsPlaceOrderBtnDisabled(false);
                                setObjRangeColor(prevData => ({ ...prevData, limit: 'color-text' }));
                            }
                        }
                        else {
                            setBIsPlaceOrderBtnDisabled(false);
                            setObjRangeColor(prevData => ({ ...prevData, limit: 'color-text' }));
                        }
                    }
                }
            }
            const newArray = prevArray.map(each => each.id === id ? { ...each, objScripInfo } : each);
            return newArray;
        });
    }, []);
    const handleAMO = (e, id) => {
        setArrScripsData(prevItem => prevItem.map(each => each.id == id ? { ...each, "AMO": e.target.checked, amoUpdated: true } : each));
    };
    const handleToggling = (e, id) => {
        const { name, value } = e.target;
        setArrScripsData(prevItem => prevItem.map(each => each.id == id ? { ...each, "ActiveButtonToggleIndex": value == 'BUY' ? 0 : 1, "BUY/SELL": value, "BtnColor": value == 'BUY' ? 'color-positive' : 'color-negative' } : each));
    };
    const onClickStopLoss = (e) => {
        setToggleStopLoss(prevState => !prevState);
    };
    const onExchangeChange = async (strExchange, id) => {
        let arrMarketPriceList = [];
        let objScripInfo = arrScripsData.find(each => each.id == id);
        let arrUpdatedOrderData = [...arrScripsData];
        let mktSegId = getMktSegIdFromApiExchangeName(`${strExchange}_EQ`);
        let exchange = getApiExchangeNameFromMktSegId(mktSegId);
        let data = await getOptionChainData({
            instrumentName: 'EQUITIES', symbol: objScripInfo["SYMBOL"][WATCHLIST_GRID_INDEX.SYMBOL], allowedId: objLoginSession.nExchangesViewAllowed
        });
        const arrWithIndex = getSearchDataAsPerSearchIndexes(data, true);
        let arrFilteredData = arrWithIndex.find(eachData => eachData[WATCHLIST_GRID_INDEX.EXCHANGE_SEGMENT] == exchange);
        let nIndex = arrUpdatedOrderData.findIndex(eachData => eachData["SYMBOL"][WATCHLIST_GRID_INDEX.SEGMENT_ID_TOKEN] == arrFilteredData[WATCHLIST_GRID_INDEX.SEGMENT_ID_TOKEN]);
        if (nIndex < 0) {
            sendTouchlineRequest([
                { exchangeId: arrFilteredData[WATCHLIST_GRID_INDEX?.SEGMENT_ID]?.length != 0 ? arrFilteredData[WATCHLIST_GRID_INDEX?.SEGMENT_ID] : 0, token: arrFilteredData[WATCHLIST_GRID_INDEX?.TOKEN]?.length != 0 ? arrFilteredData[WATCHLIST_GRID_INDEX?.TOKEN] : 0 },
            ]);
            setTimeout(() => {
                const objLastTickData = dispatch(getWfhTouchlineLastTick());
                let arrLastTick = objLastTickData[arrFilteredData[WATCHLIST_GRID_INDEX?.SEGMENT_ID_TOKEN]];
                let nRange = arrLastTick != undefined ? arrLastTick[TL_INDEX.DAILY_PRICE_RANGE] : '0.00 - 0.00';
                let price = arrLastTick?.length > 0 ? arrLastTick[TL_INDEX?.LAST_TRADE_PRICE] : '0.00';
                let objMarketPrice = {
                    id: `${arrFilteredData[WATCHLIST_GRID_INDEX?.SEGMENT_ID_TOKEN]}_${objScripInfo["BUY/SELL"]}`,
                    price
                };
                arrMarketPriceList.push(objMarketPrice);
                setArrScripsData(prevArray => {
                    const arrPrevData = [...prevArray];
                    const newObj = {
                        id: `${arrFilteredData[WATCHLIST_GRID_INDEX?.SEGMENT_ID_TOKEN]}_${objScripInfo["BUY/SELL"]}`,
                        'BUY/SELL': objScripInfo["BUY/SELL"], 'SYMBOL': arrFilteredData,
                        'EXCHANGE': arrFilteredData[WATCHLIST_GRID_INDEX.EXCHANGE],
                        "ORDER TYPE": "RL-MKT",
                        "VALIDITY": arrFilteredData[WATCHLIST_GRID_INDEX.EXCHANGE] == 'NSE' ? "DAY" : 'EOSESS',
                        "QTY": arrFilteredData[WATCHLIST_GRID_INDEX.REGULAR_LOT] > 0 ? arrFilteredData[WATCHLIST_GRID_INDEX.REGULAR_LOT] : 1,
                        "PRICE": arrLastTick?.length > 0 ? arrLastTick[TL_INDEX?.LAST_TRADE_PRICE] : '0.00',
                        "PROD TYPE": objDefaultProductType.sDescription,
                        "SL LIMIT": '0.00',
                        "SL TRIGGER": '0.00',
                        "AMO": false, "BtnColor": objScripInfo["BUY/SELL"] == 'BUY' ? 'color-positive' : 'color-negative',
                        "Range": parseFloat(Number(arrFilteredData[WATCHLIST_GRID_INDEX.DAILY_PRICE_RANGE])) != 0 ? arrFilteredData[WATCHLIST_GRID_INDEX.DAILY_PRICE_RANGE] : nRange,
                        "ActiveButtonToggleIndex": 0,
                        "amoUpdated": false
                    };
                    const arrUpdatedPrevData = arrPrevData.map(each => each.id === id ? { ...each, ...newObj } : each);
                    setObjSelectedScrip(newObj);
                    setArrMarketPrice(arrMarketPriceList);
                    dispatch(getOrderMarketPriceList(arrMarketPriceList));
                    return arrUpdatedPrevData;
                });
            }, 200);
            //BT-106965 : Ordercart : SAT2 Issues : ManasaB : 03-06-2024 : End
        }

        else {
            dispatch(toastConfig({ autoDismiss: true, show: true, message: `Selected exchange scrip is already exist in ordercart. Please choose other exchange and try again.` }));
        }
    };
    const onhandleMarketDepth = useCallback((e, arrActiveScripInformation) => {
        setIsShowMarketDepth(curr => {
            if (!curr && props?.data?.SYMBOL?.length) {
                dispatch(getExchangeWiseScripInfo(props?.data?.SYMBOL));
            }
            return !curr;
        });
        if (arrActiveScripInformation?.length != 0) {
            //  makeGridRowSelected(MULTISCRIP_ORDER_CART_GRID_REF, rowIndex);ManasaB:12-08-2024 : Not required here so commented.
            const resitancePivotObj = calculateSupportRestistanceValues(arrActiveScripInformation, 'Classic', '(H+L+C)/3');
            setSupportResistance(resitancePivotObj);
        } else { }
    }, []);
    const handleDelete = (id) => {
        setArrScripsData(prevItem => prevItem.filter(each => each.id != id));
    };
    //BT-106965 : Order Cart : Side Tray : ManasaB : 23-07-2024 - End
    let strScripCountExceedColor = layoutType == LAYOUT_TYPE.HORIZONTAL ? rowData?.length > nOrderCartCount ? 'font-medium font-size2 color-error' : 'font-regular font-size1 color-text' : arrScripsData?.length > nOrderCartCount ? 'font-medium font-size2 color-error' : 'font-regular font-size1 color-text';
    let containerRef = useRef();
    useEffect(() => {
        const arrOrderData = [...arrScripsData];
        if (arrOrderData.length > 0) {
            dispatch(getOrderDataBackupVertical([...arrOrderData]));
            handleMarginInfo([...arrOrderData]);
        }
    }, [arrScripsData]);
    //BREEZE-305 :Watchlist Side tray- Order Cart Order entry :ManasaB : 20-11-2024 : SAT issues - End

    const selectionColumnDef = useMemo(() => {
        return {
            pinned: 'left',
            hide: true,
        };
    }, []);

    const rowSelection = useMemo(() => {
        return {
            mode: GRID_ROW_SELECTION_TYPE.SINGLE_ROW,
            checkboxes: true
        };
    }, []);

    return (
        <>
            {/* BT-126347 : Brokerage and Statutory changes - Order Cart : ManasaB : 19/01/2024 - Start */}
            <BrokerageModalMultiLeg sentFrom='ordercart' orderCartInfo={orderCartInfo} />
            {/* BT-126347 : Brokerage and Statutory changes - Order Cart : ManasaB : 19/01/2024 - End */}
            {/* BT-106965 : Ordercart : SAT1 Issues : ManasaB : 18-04-2024 : Security Measure - Start */}
            {isSurvMeasure && <SurvMeasureModal arrSurvData={arrSurvMeasureData} setIsSurvMeasure={setIsSurvMeasure} isSurvMeasure={isSurvMeasure} setArrSurvMeasureData={setArrSurvMeasureData} />}
            {/* BT-106965 : Ordercart : SAT1 Issues : ManasaB : 18-04-2024 : Security Measure - End */}
            {layoutType === LAYOUT_TYPE.HORIZONTAL ?
                <>
                    <Container fluid className='p-0'>
                        <Row className='g-0 my-3'>
                            <Col md={12}>
                                <BzMasterAgGrid
                                    selectionColumnDef={selectionColumnDef}
                                    rowSelection={rowSelection}
                                    rowHeight={70}
                                    className='ag-theme-alpine multiscrip-ordercart-ag-grid-wrapper'
                                    ref={MULTISCRIP_ORDER_CART_GRID_REF}
                                    getRowId={getRowId}
                                    arrRowData={rowData}
                                    rowBuffer={1}
                                    arrColumnData={columnDefs}
                                />
                            </Col>
                        </Row>
                        <Row className='g-0 mb-3'>
                            <Col>
                                <div className='oe-horizontal-search-wrapper'>
                                    <Row className='g-0'>
                                        <div className='oe-modal-scrip-search-wrap'>
                                            <Row className='g-0 justify-content-between align-items-center'>
                                                <Col>
                                                    <div className='position-relative'>
                                                        <div className='icon-14 icon-search icon-dark search-icon-position'></div>
                                                        <BzInputText ref={inputRef} size='sm' className='font-regular text-uppercase scripname-searchtext p-l-30' type='search' name="search" placeholder='Search scrips to add above' value={strSearchInputText} onChange={(e) => onChangeTabSearch(e)} />
                                                    </div>
                                                </Col>
                                            </Row>
                                        </div>
                                        {/* BT-106965 : Ordercart : SAT1 Issues : ManasaB : 08-04-2024 - Start  */}
                                        <Col className='text-end'>
                                            <div className='font-medium font-size2 color-text'>Scrip Count : <span className={`${strScripCountExceedColor}`}>{rowData?.length}</span>/<span className='font-regular font-size1 color-text'>{nOrderCartCount}</span> </div>
                                        </Col>
                                        {/* BT-106965 : Ordercart : SAT1 Issues : ManasaB : 08-04-2024 - End  */}
                                    </Row>
                                    {orderBookSearchModal ?
                                        <div className='oe-search-wrap'>
                                            <div className='oe-search-content'>
                                                <TabsScripsList isKeyboard={false} arrGlobalScripts={arrGlobalScripts} showDefault isActive setAddToggle={setAddToggle}
                                                    strSearchInputText={strSearchInputText} orderBookSearchModal={orderBookSearchModal} setStrSearchInputText={setStrSearchInputText} addScrips={addGlobalScrips} removeScrips={onHandledelete}
                                                    scripDetails={isFlag ? globalScripDetails : arrSymbolData}
                                                    setOrderBookSearchModal={setOrderBookSearchModal}
                                                    onBuySellClick={onBuySellClick} checkBuyExisting={checkBuyExisting} checkSellExisting={checkSellExisting} />
                                            </div>
                                        </div>
                                        : ""}
                                </div>
                            </Col>
                            {/* ManasaB : 29/02/2024 : Commenting View Brokerage and charges as work is still in progress from backend - Start*/}
                            {/* <Col className='d-flex flex-column align-items-end'>
                                <BzButton className='btn btn-md btn-outline d-flex align-items-center text-capitalize'>
                                    <span>Upload Excel</span>
                                    <div className='icon-16 icon-upload icon-primary ms-2'></div>
                                </BzButton>
                                <a href='#' className='font-medium font-size1 color-primary text-center me-2 mt-2'>Download Sample</a>
                            </Col> */}
                            {/* ManasaB : 29/02/2024 : Commenting View Brokerage and charges as work is still in progress from backend - End*/}
                        </Row>

                        <Row className='g-0 py-2 bdr-top'>
                            <Col md={6} className='d-flex justify-content-start align-items-center'>
                                <div className='d-flex flex-column justify-content-start pe-4'>
                                    <div className='font-regular font-size1 color-text'>Approx. Margin</div>
                                    {
                                        isLoadingMarginInfo ?
                                            <BzDotsLoader />
                                            :
                                            rowData?.length > 0 && <div className='font-medium font-size1 color-text'>{parseFloat(totalMargin) ? convertNumberWithCommasForCurrency(parseFloat(totalMargin), true) : totalMargin}</div>
                                    }
                                </div>
                                <div className='d-flex flex-column justify-content-start pe-4'>
                                    <div className='font-regular font-size1 color-text'>Available Margin</div>
                                    {

                                        isLoadingMarginInfo ?
                                            <BzDotsLoader />
                                            :
                                            rowData?.length > 0 && <div className='font-medium font-size1 color-text'>{!isNaN(parseFloat(arrMarginInfo?.AvailableMargin)) ? convertNumberWithCommasForCurrency(parseFloat(arrMarginInfo?.AvailableMargin), true) : arrMarginInfo?.AvailableMargin}</div>
                                    }
                                </div>
                                <div className='d-flex align-items-center pe-4 cursor-pointer focus' onClick={() => calculatedAndGetOrderMarginInfoFor([...rowData])}>
                                    <div className='icon-12 icon-refresh background-textual-link-withicon'></div>
                                    <div className='font-medium font-size1 color-textual-link-withicon ms-2'>Update</div>
                                </div>
                            </Col>
                            <Col md={6} className='d-flex justify-content-end align-items-center'>
                                <BzButton disabled={bDisableSaveBtn} className='btn btn-md btn-primary text-capitalize' onClick={handleOpenOrderNameModal}>SAVE CART &amp; PLACE ORDER</BzButton>
                            </Col>
                        </Row>
                        {
                            isShowMarketDepth &&
                            <Row className='bdr-top px-2 py-3 mt-3'>
                                <Container fluid className='p-0'>
                                    <Row className='g-0'>
                                        <Col className='d-flex justify-content-start align-items-center'>
                                            <div className='submenu-wrapper d-flex align-items-center'>
                                                <div onClick={() => setMarketDepthActiveTab('MarketDepth')} className={`submenuItem ${marketDepthActiveTab == 'MarketDepth' ? 'active' : ''}`}>Market Depth</div>
                                                <div onClick={() => setMarketDepthActiveTab('supportResistance')} className={`submenuItem ${marketDepthActiveTab == 'supportResistance' ? 'active' : ''}`}>Support/Resistance</div>
                                            </div>
                                        </Col>
                                    </Row>
                                </Container>
                                <div>
                                    {marketDepthActiveTab === "MarketDepth" ? <AllExchangesMarketDepth onValueClick={onValueClick} heading={false} /> : marketDepthActiveTab === "supportResistance" ? <SupportResistance supportResistance={supportResistance} strViewFrom={SUPPORT_RESISTANCE_VIEW.ORDER_ENTRY} /> : null}
                                </div>
                            </Row>
                        }
                    </Container>
                </>
                : (
                    layoutType === LAYOUT_TYPE.VERTICAL ?
                        // ManasaB:07-10-14 : UI changes taken from release branch - Start
                        <>
                            <div className='font-medium font-size2 color-text px-3'>Scrip Count: <span className={`${strScripCountExceedColor}`}>{arrScripsData?.length}</span> / <span className='font-regular font-size1 color-text'>{nOrderCartCount}</span></div>
                            <div className='sticky-orderticket-ordercart'>
                                <Container fluid className='p-0 pb-3 px-3'>
                                    {
                                        arrScripsData && arrScripsData.length > 0 && arrScripsData?.map(eachData => {

                                            return <>
                                                <div id={eachData?.id} className='ordercart-card p-3 my-3'>
                                                    <Row className="g-0">
                                                        <Col>
                                                            <div className='font-medium font-size3 color-text'>{eachData["SYMBOL"][WATCHLIST_GRID_INDEX.SYMBOL]}</div>
                                                            <div className='d-flex align-items-center flex-wrap'>
                                                                <div className='chips-wrap'>
                                                                    <div className='exchange-chip text-uppercase'>{eachData["EXCHANGE"]}</div>
                                                                </div>
                                                                <div className='font-medium font-size1 color-subtext text-capitalize mx-2'>{eachData["SYMBOL"][WATCHLIST_GRID_INDEX.SERIES]}</div>
                                                                <div className='chips-wrap my-1 me-2'>
                                                                    <div className='chips primary-chip text-capitalize'>{eachData["PROD TYPE"]}</div>
                                                                </div>
                                                            </div>
                                                            <div className={`font-medium font-size3 ${eachData["BtnColor"]}`}>{eachData["BUY/SELL"]}<span className='font-regular color-text ms-1'>@ &#8377;{eachData["PRICE"]}</span></div>
                                                        </Col>
                                                        {(bIsShowScripDetails && Object.keys(objSelectedScrip.length > 0) && objSelectedScrip.id == eachData["id"]) ?
                                                            <div className='icon-16 icon-arrowup icon-dark ms-3' onClick={(event) => handleHideScripDetails(event, eachData)}></div>
                                                            : <> <Col md={4} className='d-flex flex-column justify-content-between align-items-end'>
                                                                <div className='d-flex align-tems-center'>
                                                                    {/* BREEZE-305 : ManasaB : 16-10-2024 : Watchlist Side tray- Order Cart Order entry - Start */}
                                                                    {arrScripsData.length != 1 && <div className='icon-16 icon-delete icon-dark ms-3' onClick={handleDelete.bind(this, eachData.id)}></div>}
                                                                    {/* BREEZE-305 : ManasaB : 16-10-2024 : Watchlist Side tray- Order Cart Order entry - End */}
                                                                    <div className='icon-16 icon-edit icon-dark ms-3' onClick={(event) => handleEdit(event, eachData)}></div>
                                                                </div>
                                                                <div className='input-group postion-relative'>
                                                                    <div className='icon-12 icon-order-decrease input-number-left-wrap' onClick={handleQuantityIncDec.bind(this, "subQuantity", eachData.id)}></div>
                                                                    <BzInputText size='sm' type='text' className='font-regular text-center' value={eachData["QTY"]} onChange={(e) => handleQuantity(e, eachData.id)} />
                                                                    <div className='icon-12 icon-order-increase input-number-right-wrap' onClick={handleQuantityIncDec.bind(this, "addQuantity", eachData.id)}></div>
                                                                </div>
                                                            </Col></>}
                                                    </Row>
                                                    {
                                                        (bIsShowScripDetails && objSelectedScrip["id"] == eachData["id"]) ?
                                                            <>
                                                                <Row className='g-0 mb-3'>
                                                                    <Col className='d-flex justify-content-end'>
                                                                        <BzToggleButton
                                                                            wrapperClassName='buysell-wrap'
                                                                            leftButtonClassName={`btn btn-sm ${eachData["ActiveButtonToggleIndex"] === 0 ? 'btn-positive' : ''}`}
                                                                            rightButtonClassName={`btn btn-sm ${eachData["ActiveButtonToggleIndex"] === 1 ? 'btn-negative' : ''}`}
                                                                            leftButtonTitle="BUY" rightButtonTitle="SELL" activeButtonToggleIndex={eachData["ActiveButtonToggleIndex"]} setActiveButtonToggleIndex={(e) => handleToggling({ target: { name: "activeButtonToggleIndex", value: e === 0 ? "BUY" : "SELL" }, }, eachData.id)} />
                                                                    </Col>
                                                                </Row>
                                                                <Row className='g-0 mb-3'>
                                                                    <Col className='d-flex align-items-center horizontal-scroll-wrap pb-1'>
                                                                        <div className='exch-radiochip-wrap ms-auto'>
                                                                            {/* ManasaB :23-11-2024 : Added loop for exchanges after discussion with Ajitesh and Sumit - Start */}
                                                                            {arrDistinctScripExchanges?.length > 0 && arrDistinctScripExchanges?.map((eachExchange, i) => {
                                                                                return (
                                                                                    <BzChip onClick={(e) => onExchangeChange(eachExchange[WATCHLIST_GRID_INDEX.EXCHANGE], eachData.id)} className={`radio-chip ms-2 ${eachData["EXCHANGE"] === eachExchange[WATCHLIST_GRID_INDEX.EXCHANGE] && eachData["SYMBOL"][WATCHLIST_GRID_INDEX.SEGMENT_ID] === eachExchange[WATCHLIST_GRID_INDEX.SEGMENT_ID] ? 'active' : ''}`}>
                                                                                        <div className={`exch-namechip ${eachData["EXCHANGE"] === eachExchange[WATCHLIST_GRID_INDEX.EXCHANGE] && eachData["SYMBOL"][WATCHLIST_GRID_INDEX.SEGMENT_ID] === eachExchange[WATCHLIST_GRID_INDEX.SEGMENT_ID] ? 'active' : ''}`}>{eachExchange[WATCHLIST_GRID_INDEX.EXCHANGE]}</div>
                                                                                        <div className='font-regular font-size1 color-text text-end'>{eachData["BUY/SELL"] == "BUY" ? eachExchange[WATCHLIST_GRID_INDEX.ASK_PRICE] : eachExchange[WATCHLIST_GRID_INDEX.BID_PRICE]}</div>
                                                                                        <div className='font-regular font-size1 color-subtext text-end'>QTY: {eachData["BUY/SELL"] == "BUY" ? eachExchange[WATCHLIST_GRID_INDEX.ASK_QTY] : eachExchange[WATCHLIST_GRID_INDEX.BID_QUANTITY]}</div>
                                                                                    </BzChip>
                                                                                );
                                                                            })}
                                                                            {/* ManasaB :23-11-2024 : Added loop for exchanges after discussion with Ajitesh and Sumit - End */}
                                                                        </div>
                                                                    </Col>
                                                                </Row>
                                                                <Row className='mb-3'>
                                                                    <Col md={6}>
                                                                        <div className='font-regular font-size3 color-subtext mb-1'>Product Type</div>
                                                                        <div className='Bzmodalselect-dropdown'>
                                                                            <BzDropdown>
                                                                                <Dropdown.Toggle className='btn-default'>{eachData["PROD TYPE"]}</Dropdown.Toggle>
                                                                                <Dropdown.Menu>
                                                                                    {arrProdTypes?.length > 0 && arrProdTypes?.map((eachOption, i) => (
                                                                                        <Dropdown.Item key={i} onClick={(e) => handleDropdown({ target: { value: eachOption?.sDefaultProductType, name: 'productType' } }, eachData.id)}>{eachOption?.sDescription}</Dropdown.Item>
                                                                                    ))}
                                                                                </Dropdown.Menu>
                                                                            </BzDropdown>
                                                                        </div>
                                                                    </Col>
                                                                    <Col md={6}>
                                                                        <div className='font-regular font-size3 color-subtext mb-1'>Order Type</div>
                                                                        <div className='Bzmodalselect-dropdown'>
                                                                            <BzDropdown>
                                                                                <Dropdown.Toggle className='btn-default'>{eachData["ORDER TYPE"]}</Dropdown.Toggle>
                                                                                <Dropdown.Menu>
                                                                                    {objDropdownOptions.orderType?.length > 0 && objDropdownOptions.orderType?.map((eachOption, i) => (
                                                                                        <Dropdown.Item key={i} onClick={(e) => handleDropdown({ target: { value: eachOption, name: 'orderType' } }, eachData.id)}>{eachOption}</Dropdown.Item>
                                                                                    ))}
                                                                                </Dropdown.Menu>
                                                                            </BzDropdown>
                                                                        </div>
                                                                    </Col>
                                                                </Row>
                                                                <Row className='mb-3'>
                                                                    <Col md={6} className='flex-column align-items-start'>
                                                                        <div className='d-flex align-items-center mb-1'>
                                                                            <div className='font-regular font-size3 color-subtext'>Quantity</div>
                                                                            <div className='icon-12 icon-arrowdown icon-dark ms-1'></div>
                                                                        </div>
                                                                        <div className='input-group postion-relative'>
                                                                            <div className='icon-12 icon-order-decrease input-number-left-wrap' onClick={handleQuantityIncDec.bind(this, "subQuantity", eachData.id)}></div>
                                                                            <BzInputText size='sm' type='number' className='font-regular text-center' value={eachData["QTY"]} onChange={(e) => handleQuantity(e, eachData.id)} />
                                                                            <div className='icon-12 icon-order-increase input-number-right-wrap' onClick={handleQuantityIncDec.bind(this, "addQuantity", eachData.id)}></div>
                                                                        </div>
                                                                    </Col>
                                                                    <Col md={6} className='flex-column align-items-start'>
                                                                        <div className='d-flex align-items-center justify-content-between mb-1'>
                                                                            <div className='font-regular font-size3 color-subtext'>Price</div>
                                                                            <div className='icon-20 icon-marketdepth ms-3' onClick={onhandleMarketDepth}></div>
                                                                        </div>
                                                                        <div className='input-group postion-relative'>
                                                                            <div className={`icon-12 icon-order-decrease input-number-left-wrap ${!(["RL"].includes(eachData["ORDER TYPE"])) && 'div-disabled'}`} onClick={handlePriceIncDec.bind(this, "subPrice", eachData.id)} ></div>
                                                                            <BzInputText size='sm' type='number' className='font-regular text-center' value={eachData["PRICE"]} onChange={(e) => handlePrice(e, eachData.id)} onBlur={(e) => handlePriceBlur(e, eachData.id)} disabled={!(["RL"].includes(eachData["ORDER TYPE"]))} />
                                                                            <div className={`icon-12 icon-order-increase input-number-right-wrap ${!(["RL"].includes(eachData["ORDER TYPE"])) && ' div-disabled'}`} onClick={handlePriceIncDec.bind(this, "addPrice", eachData.id)} ></div>
                                                                        </div>
                                                                        <div className='d-flex align-items-center mt-2'>
                                                                            <BzToolTip placement='left' TooltipMsg='You can place your order within this price range.It is rectified by the exchanges or the nature of trading you are placing.'>
                                                                                <div className='icon-16 icon-info icon-dark flex-shrink-0'></div>
                                                                            </BzToolTip>
                                                                            <div className='font-regular font-size2 color-subtext ms-1'>Range: <span className={`font-regular font-size1 color-text ${objRangeColor.price}`}>{eachData["Range"]}</span></div>
                                                                        </div>
                                                                    </Col>
                                                                </Row>
                                                                <Row className='mb-3 align-items-center'>
                                                                    <Col md='auto'>
                                                                        <div className='d-flex align-items-center focus'>
                                                                            <div className='font-medium font-size3 color-text cursor-pointer' onClick={onClickStopLoss.bind(this)} >
                                                                                {'STOP LOSS'}
                                                                            </div>
                                                                            <div className='d-flex align-items-start cursor-pointer' onClick={onClickStopLoss.bind(this)}>{toggleStopLoss ? <div className='icon-16 icon-minus-circle-fill icon-dark ms-2'> </div> : <div className='icon-16 icon-add-circle-fill icon-dark ms-2'></div>}</div>
                                                                        </div>
                                                                    </Col>
                                                                </Row>
                                                                {toggleStopLoss && eachData["ORDER TYPE"] != ORDER_ENTRY_TYPES.RL ?
                                                                    <Row className='mb-3'>
                                                                        <Col md={6} className='flex-column align-items-start'>
                                                                            <div className='d-flex align-items-center mb-1'>
                                                                                <div className='font-regular font-size3 color-subtext'>SL Trigger</div>
                                                                                <div className='icon-20 icon-marketdepth ms-3' onClick={onhandleMarketDepth}></div>
                                                                            </div>
                                                                            <div className='input-group postion-relative'>
                                                                                <div className={`icon-12 icon-order-decrease input-number-left-wrap ${!(["SL-MKT", "SL"].includes(eachData["ORDER TYPE"])) && ' div-disabled'}`} onClick={handleSLTriggerIncDec.bind(this, "subSLTrigger", eachData.id)}></div>
                                                                                <BzInputText size='sm' type='number' className='font-regular text-center' onFocus={() => handleTriggerFocus(eachData.id)} value={eachData["SL TRIGGER"]} onChange={(e) => handleSLTrigger(e, eachData.id)} onBlur={handleTriggerBlur.bind(this, eachData.id)} disabled={!(["SL-MKT", "SL"].includes(eachData["ORDER TYPE"]))} />
                                                                                <div className={`icon-12 icon-order-increase input-number-right-wrap ${!(["SL-MKT", "SL"].includes(eachData["ORDER TYPE"])) && ' div-disabled'}`} onClick={handleSLTriggerIncDec.bind(this, "addSLTrigger", eachData.id)}></div>
                                                                            </div>
                                                                            <div className='d-flex align-items-center mt-2'>
                                                                                <BzToolTip placement='left' TooltipMsg='Your order will be executed at available SL limit price when Trigger price is reached.'>
                                                                                    <div className='icon-16 icon-info icon-dark flex-shrink-0'></div>
                                                                                </BzToolTip>
                                                                                <div className='font-regular font-size2 color-subtext ms-1'>Range: <span className={`font-regular font-size2 ${objRangeColor.trigger}`}>{eachData["Range"]}</span></div>
                                                                            </div>
                                                                        </Col>
                                                                        <Col md={6} className='flex-column align-items-start'>
                                                                            <div className='d-flex align-items-center mb-1'>
                                                                                <div className='font-regular font-size3 color-subtext'>SL Limit</div>
                                                                                <div className='icon-20 icon-marketdepth ms-3' onClick={onhandleMarketDepth}></div>
                                                                            </div>
                                                                            <div className='input-group postion-relative'>
                                                                                <div className={`icon-12 icon-order-decrease input-number-left-wrap ${!(["SL"].includes(eachData["ORDER TYPE"])) && ' div-disabled'}`} onClick={handleSLLimitIncDec.bind(this, "subSLLimit", eachData.id)}></div>
                                                                                <BzInputText size='sm' type='number' className='font-regular text-center' onFocus={() => handleLimitFocus(eachData.id)} value={eachData["SL LIMIT"]} onChange={(e) => handleSLLimit(e, eachData.id)} onBlur={handleLimitBlur.bind(this, eachData.id)} disabled={!(["SL"].includes(eachData["ORDER TYPE"]))} />
                                                                                <div className={`icon-12 icon-order-increase input-number-right-wrap ${!(["SL"].includes(eachData["ORDER TYPE"])) && 'div-disabled'}`} onClick={handleSLLimitIncDec.bind(this, "addSLLimit", eachData.id)}></div>
                                                                            </div>
                                                                            <div className='d-flex align-items-center mt-2'>
                                                                                <BzToolTip placement='left' TooltipMsg='You can place your order within this price range.It is rectified by the exchanges or the nature of trading you are placing.'>
                                                                                    <div className='icon-16 icon-info icon-dark flex-shrink-0'></div>
                                                                                </BzToolTip>
                                                                                <div className='font-regular font-size2 color-subtext ms-1'>Range: <span className={`font-regular font-size2 ${objRangeColor.limit}`}>{eachData["Range"]}</span></div>
                                                                            </div>
                                                                        </Col>
                                                                    </Row> : null}
                                                                <Row className='mb-3'>
                                                                    <Col md={6}>
                                                                        <div className='font-regular font-size3 color-subtext mb-1'>Validity</div>
                                                                        <div className='Bzmodalselect-dropdown'>
                                                                            <BzDropdown>
                                                                                <Dropdown.Toggle className='btn-default'>{eachData["VALIDITY"]}</Dropdown.Toggle>
                                                                                <Dropdown.Menu>
                                                                                    {eachData["EXCHANGE"] == 'NSE' ?
                                                                                        objDropdownOptions.validityNSE?.length > 0 && objDropdownOptions.validityNSE?.map((eachOption, i) => (
                                                                                            <Dropdown.Item key={i} onClick={(e) => handleDropdown({ target: { value: eachOption, name: 'validity' } }, eachData.id)}>{eachOption}</Dropdown.Item>
                                                                                        )) :
                                                                                        objDropdownOptions.validityBSE?.length > 0 && objDropdownOptions.validityBSE?.map((eachOption, i) => (
                                                                                            <Dropdown.Item key={i} onClick={(e) => handleDropdown({ target: { value: eachOption, name: 'validity' } }, eachData.id)}>{eachOption}</Dropdown.Item>
                                                                                        ))
                                                                                    }
                                                                                </Dropdown.Menu>
                                                                            </BzDropdown>
                                                                        </div>
                                                                    </Col>
                                                                    <Col md={6} className='d-flex align-items-center mt-4'>
                                                                        <input type='checkbox' className='form-check-input me-2' checked={eachData["AMO"]} onChange={(e) => handleAMO(e, eachData.id)} />
                                                                        <div className='font-medium font-size1 color-text text-uppercase'>AMO</div>
                                                                    </Col>
                                                                </Row>
                                                            </>
                                                            : null
                                                    }
                                                </div ></>;
                                        })}
                                    {
                                        bIsShowSearchScrip == false ?

                                            <Row className='g-0 mb-3'>
                                                <Col>
                                                    <BzButton className="btn btn-outline btn-sm d-flex align-items-center" onClick={handleAddScrips}>
                                                        <div className="icon-16 icon-add-circle-fill icon-primary me-2"></div>
                                                        <span className='font-medium font-size1'>Add Scrip</span>
                                                    </BzButton>
                                                </Col>
                                                {/* ManasaB : 18-10-2024 : Commented Temporarily - Start */}
                                                {/* <Col className='d-flex flex-column align-items-end'>
                                            <BzButton className='btn btn-outline btn-sm d-flex align-items-center'>
                                                <span>Upload Excel</span>
                                                <div className='icon-16 icon-upload icon-primary ms-2'></div>
                                            </BzButton>
                                            <a href='#' className='font-medium font-size1 color-primary text-center mt-2'>Download Sample File</a>
                                        </Col> */}
                                                {/* ManasaB : 18-10-2024 : Commented Temporarily - End */}
                                            </Row> :
                                            <Row className='g-0 mb-3 justify-content-center'>
                                                <Col md={12} className='d-flex align-items-center'>
                                                    <div className='position-relative w-100'>
                                                        <div className="icon-14 icon-search icon-grey search-icon-position"></div>
                                                        <BzInputText size='sm' type='search' className='p-l-30 font-regular' placeholder='Search scrips to add...' value={strSearchInputText} onChange={(e) => onChangeTabSearch(e)}></BzInputText>
                                                    </div>
                                                    <div className="icon-20 icon-close-fill icon-primary ms-1 flex-shrink-0" onClick={() => setBIsShowSearchScrip(false)}></div>
                                                </Col>
                                                <div className="oe-vertical-search-wrapper">
                                                    <div className="oe-search-content">
                                                        {orderBookSearchModal ?
                                                            <div className='oe-search-wrap'>
                                                                <div className='oe-search-content'>
                                                                    <TabsScripsList isKeyboard={false} arrGlobalScripts={arrGlobalScripts} showDefault isActive setAddToggle={setAddToggle}
                                                                        strSearchInputText={strSearchInputText} orderBookSearchModal={orderBookSearchModal} setStrSearchInputText={setStrSearchInputText} addScrips={addGlobalScrips} removeScrips={onHandledelete}
                                                                        scripDetails={isFlag ? globalScripDetails : arrSymbolData}
                                                                        setOrderBookSearchModal={setOrderBookSearchModal}
                                                                        onBuySellClick={onBuySellClick} checkBuyExisting={checkBuyExisting} checkSellExisting={checkSellExisting} />
                                                                </div>
                                                            </div>
                                                            : ""}
                                                    </div>
                                                </div>
                                            </Row>}
                                    {
                                        isShowMarketDepth &&
                                        <Row className='g-0 bdr-top px-2 py-3'>
                                            <Row className='g-0'>
                                                <Col md={12} className='d-flex justify-content-start align-items-center'>
                                                    <Button className={marketDepthActiveTab === "MarketDepth" ? 'btn btn-sm btn-primary btn-rounded me-2' : 'btn btn-sm btn-default btn-rounded me-2'} onClick={() => setMarketDepthActiveTab('MarketDepth')}>Market Depth</Button>
                                                    <Button className={marketDepthActiveTab === "supportResistance" ? 'btn btn-sm btn-primary btn-rounded' : 'btn btn-sm btn-default btn-rounded'} onClick={() => setMarketDepthActiveTab('supportResistance')}>Support/Resistance</Button>
                                                </Col>
                                            </Row>
                                            {marketDepthActiveTab === "MarketDepth" ?
                                                <>
                                                    <BzTabs className='nav nav-tabs horizontal-scroll-wrap my-2 d-flex flex-row'>
                                                        {
                                                            arrDistinctScripExchanges?.length > 0 && arrDistinctScripExchanges?.map((each, i) =>
                                                                <BzTab key={i} className={`nav-link text-capitalize ${each[WATCHLIST_GRID_INDEX.SEGMENT_ID] == marketDepthTab ? 'active' : ''}`} tabKey={each[WATCHLIST_GRID_INDEX.SEGMENT_ID]} onClick={() => setMarketDepthTab(each[WATCHLIST_GRID_INDEX.SEGMENT_ID])}>
                                                                    {each[WATCHLIST_GRID_INDEX.EXCHANGE]}
                                                                </BzTab>
                                                            )
                                                        }
                                                    </BzTabs>
                                                    {
                                                        arrDistinctScripExchanges?.length > 0 && arrDistinctScripExchanges?.map((each, i) =>
                                                            each[WATCHLIST_GRID_INDEX.SEGMENT_ID] == marketDepthTab && <MarketDepthGrid onValueClick={onValueClick} layoutType={LAYOUT_TYPE.VERTICAL} ref={[createRef(), createRef()]} key={i} scripData={each} />
                                                        )
                                                    }
                                                </>
                                                : marketDepthActiveTab === "supportResistance" ? <SupportResistance supportResistance={supportResistance} strViewFrom={SUPPORT_RESISTANCE_VIEW.ORDER_ENTRY} /> : null}
                                        </Row>
                                    }
                                </Container>
                            </div>
                        </>
                        // ManasaB:07-10-14 : UI changes taken from release branch -End
                        : null
                )
            }
        </>
    );
});

export default memo(Basket);